<template>
  <div class="row justify-content-center mt-4">
    <!-- MODALES  -->

    <!-- MODAL TIPS -->
    <Modal :name="'modalTips'" :size="'30'">
      <div class="bg-custon-gray rounded p-3">
        <p class="my-3 mx-2">
          <span>
            <img
              width="35px"
              class="rounded-circle d-inline"
              src="@/assets/images/oliver-b-1.png"
              alt=""
            />
          </span>
          <strong class="ml-2">Tips</strong>
        </p>
        <p class="my-3 mx-2 small">
          <strong>
            {{
              $t("lang.orders.sequence_tip_1").substr(
                0,
                $t("lang.orders.sequence_tip_1").indexOf(":")
              )
            }}
          </strong>
          {{
            $t("lang.orders.sequence_tip_1")
              .substr($t("lang.orders.sequence_tip_1").indexOf(":"))
              .replace(
                /\[(company_name|nombre_de_empresa)]/gi,
                " " + currentUser.client_name
              )
          }}
        </p>

        <p class="my-3 mx-2 small">
          <strong>
            {{
              $t("lang.orders.sequence_tip_2").substr(
                0,
                $t("lang.orders.sequence_tip_2").indexOf(":")
              )
            }}
          </strong>
          {{
            $t("lang.orders.sequence_tip_2")
              .substr($t("lang.orders.sequence_tip_2").indexOf(":"))
              .replace(
                /\[(company_name|nombre_de_empresa)]/gi,
                currentUser.client_name
              )
          }}
        </p>
        <p class="my-3 mx-2 small">
          <strong>
            {{
              $t("lang.orders.sequence_tip_3").substr(
                0,
                $t("lang.orders.sequence_tip_3").indexOf(":")
              )
            }}
          </strong>
          {{
            $t("lang.orders.sequence_tip_3").substr(
              $t("lang.orders.sequence_tip_3").indexOf(":")
            )
          }}
        </p>
        <p class="my-3 mx-2 small">
          <strong>
            {{
              $t("lang.orders.sequence_tip_4").substr(
                0,
                $t("lang.orders.sequence_tip_4").indexOf(":")
              )
            }}
          </strong>
          {{
            $t("lang.orders.sequence_tip_4").substr(
              $t("lang.orders.sequence_tip_4").indexOf(":")
            )
          }}
        </p>
        <p class="my-3 mx-2 small">
          <strong>
            {{
              $t("lang.orders.sequence_tip_5").substr(
                0,
                $t("lang.orders.sequence_tip_5").indexOf(":")
              )
            }}
          </strong>
          {{
            $t("lang.orders.sequence_tip_5").substr(
              $t("lang.orders.sequence_tip_5").indexOf(":")
            )
          }}
        </p>
      </div>
    </Modal>

    <!-- MODAL E-MAILS -->
    <Modal :name="'mails'">
      <div class="px-4 d-inline">
        <Tabs
          :tabSelected="Number(onBoarding.modelCampaingStep.tabSelected.id)"
          :tabs="onBoarding.tabs"
          @change="changeTab($event)"
        />
      </div>
      <div class="row">
        <div class="col-12">
          <button
            class="float-right btn cursor-pointer font-weight-bolder btn-sm btn-primary mr-3 px-4"
            type="button"
            @click="
              savenow(false, false);
              closeModal('mails');
            "
            v-if="!disabledEdit()"
          >
            {{ $t("lang.button.sequence_type") }}
          </button>
          <button
            class="float-right btn cursor-pointer font-weight-bolder btn-sm btn-primary mr-3 px-4"
            type="button"
            @click="generateSequences()"
            v-if="this.$store.state.authentication.user.role_id == 1"
          >
            Generate Sequences
          </button>
          <h4 class="font-weight-bold text-center">{{ onBoarding.orderName }}</h4>
        </div>
      </div>

      <div
        class="text-align-center p-4"
        v-if="onBoarding.modelCampaingStep.tabSelected.id == 1"
      >
        <div class="card mb-5">
          <LoadingSpinner class="mr-5" v-if="sequences_IA_loading" />
          <CustomMsg
            v-if="!sequences_IA_loading"
            :availableTokens="newAvailableToken"
            :availableTokensSelect="newAvailableToken"
            :model="onBoarding.modelCampaingStep"
            :onboarding="true"
            :sequences_IA="sequences_IA"
            @update="saveTargetCampaignStep($event)"
          />
        </div>
      </div>
      <div
        class="p-4 text-left"
        v-if="onBoarding.modelCampaingStep.tabSelected.id == 2"
      >
        <h4 class="card-title text-primary mb-2">
          {{ $t("lang.onBoarding.mails_modal_title") }}
        </h4>
        <span class="text-secondary mb-3">{{
          $t("lang.onBoarding.mails_modal_description")
        }}</span>
        <div class="row">
          <div
            class="col-md-5 p-0"
            :class="{ 'border border-warning rounded': step1hasError }"
          >
            <div
              v-if="step1hasError"
              class="row my-3 mx-3 py-1 bg-warning text-dark text-bold text-center"
            >
              <div class="col-8">
                <span class="pt-1 font-weight-bold">{{
                  $t("lang.onBoarding.complete_this_before_campaign")
                }}</span>
              </div>
              <div class="col-3">
                <button
                  class="btn large cursor-pointer font-weight-bolder btn-sm btn-light mx-1"
                  @click="goToSubStep(1, 0)"
                >
                  {{ $t("lang.onBoarding.go_step_by_step") }}
                </button>
              </div>
            </div>
            <Step1Summary @save="mailmodalkey++" />
          </div>
          <div class="col-md-7">
            <!-- <TargetStepCampaingPreview
                  v-if="
                    !disabledEdit() &&
                    previewTemplate() &&
                    !loading
                  "
                  :model="modelCampaingStep"
                  :availableTokens="availableTokens"
                  :preview="false"
                  :availableTokensSelect="availableTokens"
                /> -->
            <MailsModal :key="mailmodalkey" :tag_id="tag_id" />
          </div>
          <button
            class="float-right btn cursor-pointer font-weight-bolder btn-sm btn-primary m-1 px-4"
            type="button"
            @click="
              savenow(false, false);
              closeModal('mails');
            "
            v-if="!disabledEdit()"
          >
            {{ $t("lang.button.save") }}
          </button>
        </div>
      </div>

      <div
        class="d-inline px-2"
        v-if="onBoarding.modelCampaingStep.tabSelected.id == 3"
      >
        <div class="row">
          <div class="col-12">
            <TargetSequences :targetId="onBoarding.orderId"></TargetSequences>
          </div>
        </div>
      </div>
    </Modal>

    <Modal :name="'start-campaings'" :close="false">
      <div class="row justify-content-center" v-if="loadingEmailSequence">
        <div class="col-1">
          <LoadingSpinner class="mr-5" v-if="loadingEmailSequence" />
          <span class="mb-5 -mt-5" v-if="loadingEmailSequence">{{
            $t("lang.search.loading")
          }}</span>
        </div>
      </div>

      <div v-if="!loadingEmailSequence">
        <div class="row p-4 justify-content-center">
          <div class="col text-center mt-3">
            <h4 class="mx-3">
              {{ $t("lang.onBoarding.confirmemailsequence") }}
            </h4>
          </div>
        </div>
        <div class="row p-4 justify-content-center">
          <div class="col-md-8">
            <div class="bg-light text-dark rounded p-2">
              <img src="@/assets/images/2 (1).png" width="50px" alt="" />
              <p class="d-inline p-2 font-weight-bold">OliverTips</p>
              <p class="p-2">
                {{ $t("lang.onBoarding.emailsequencetip") }}
              </p>
            </div>
          </div>
        </div>
        <div class="row justify-content-center p-4">
          <div class="col-md-8">
            <MailsModal :key="mailmodalkey" :simplify="true" :tag_id="tag_id" />
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-md-7">
            <div class="display mt-2 mb-5">
              < class="text-secondary">
                <input
                  class="d-inline mr-2 mt-2 cursor-pointer"
                  type="checkbox"
                  v-model="oliverEmailSequence"
                />
                {{ $t("lang.onBoarding.checkemailsequence") }}
              </>
            </div>

            <button
              class="btn cursor-pointer font-weight-bolder btn-sm btn-secondary mr-5 m-1 mt-2 px-4"
              type="button"
              @click="$modal.hide('start-campaings'), $modal.show('mails')"
            >
              {{ $t("lang.button.gobackedit") }}
            </button>
            <button
              class="btn cursor-pointer font-weight-bolder btn-sm btn-primary m-1 ml-5 mt-2 px-4"
              :disabled="oliverEmailSequence ? false : true"
              type="button"
              @click="savenow(true, true), (loadingEmailSequence = true)"
            >
              {{ $t("lang.onBoarding.start_preparing_my_campaigns") }}
              <span class="img-btn">
                <img src="@/assets/images/icono-wp.png" alt />
              </span>
            </button>
          </div>
        </div>
      </div>
    </Modal>

    <!-- MODAL FALTANTE DE DATOS -->
    <Modal :name="'Errors'" :resizable="false" height="auto" size="80">
      <div class="row p-4 text-left">
        <div class="col text-center mt-3">
          <h4 class="mx-3">{{ $t("lang.label.missingdata") }}</h4>
        </div>
      </div>
      <div class="row">
        <!-- <LoadingSpinner v-if="loadingGetApollo" /> -->
        <div class="col-md-12">
          <div class="card-body pt-1">
            <div class="row justify-content-center">
              <div class="col-md-11">
                <div id="accordion">
                  <!-- <div class="card">
                    <div class="card-header mb-0" id="headingTwo">
                      <h5 class="mb-0">
                        <button
                          class="btn btn-link collapsed"
                          data-toggle="collapse"
                          data-target="#collapseTwo"
                          aria-expanded="false"
                          aria-controls="collapseTwo"
                        >
                          {{ $t("lang.onBoarding.serviceDescription") }}
                        </button>
                      </h5>
                    </div>
                    <div
                      id="collapseTwo"
                      class="collapse show"
                      aria-labelledby="headingTwo"
                      data-parent="#accordion"
                    >
                      <div class="card-body">
                        <li class="list-group-item border-0">
                          <i class="icon-circle mr-1 text-danger"></i>
                          {{ this.$t("lang.onBoarding.notDescribeService") }}
                        </li>
                        <li>
                          <button
                            class="btn btn-sm mx-4 btn-primary float-end"
                            @click="
                              onBoarding.step3.tabId = 2;
                              $modal.hide('Errors');
                            "
                          >
                            {{ this.$t("lang.orders.fix_it") }}
                          </button>
                        </li>
                        <div class="float-end"></div>
                      </div>
                    </div>
                  </div> -->
                  <div
                    class="card"
                    v-if="
                      onBoarding.step3.teamMembers.length == 0 &&
                        onBoarding.typeForm == 'onboarding'
                    "
                  >
                    <div class="card-header mb-0" id="headingTwo">
                      <h5 class="mb-0">
                        <button
                          class="btn btn-link collapsed"
                          data-toggle="collapse"
                          data-target="#collapseTwo"
                          aria-expanded="false"
                          aria-controls="collapseTwo"
                        >
                          {{ $t("lang.onBoarding.who_is_thesales") }}
                        </button>
                      </h5>
                    </div>
                    <div
                      id="collapseTwo"
                      class="collapse show"
                      aria-labelledby="headingTwo"
                      data-parent="#accordion"
                    >
                      <div class="card-body">
                        <li class="list-group-item border-0">
                          <i class="icon-circle mr-1 text-danger"></i>
                          {{ this.$t("lang.orders.unavailablesales") }}
                        </li>
                        <li>
                          <button
                            class="btn btn-sm mx-4 btn-primary float-end"
                            @click="
                              onBoarding.step3.tabId = 1;
                              $modal.hide('Errors');
                            "
                          >
                            {{ this.$t("lang.orders.fix_it") }}
                          </button>
                        </li>
                      </div>
                    </div>
                  </div>
                  <div
                    class="card mt-2"
                    v-if="isActivationOrder && onBoarding.activationContactsCount < 1"
                  >
                    <div class="card-header mb-0" id="headingActivation">
                      <h5 class="mb-0">
                        <button
                          class="btn btn-link collapsed"
                          data-toggle="collapse"
                          data-target="#collapseActivation"
                          aria-expanded="false"
                          aria-controls="collapseActivation"
                        >
                          {{ $t("lang.orders.your_targeting") }}
                        </button>
                      </h5>
                    </div>
                    <div
                      id="collapseActivation"
                      class="collapse show"
                      aria-labelledby="headingActivation"
                      data-parent="#accordion"
                    >
                      <div class="card-body">
                        <li class="list-group-item border-0">
                          <i class="icon-circle mr-1 text-danger"></i>
                          {{ $t("lang.orders.activation_import_validate_empty") }}
                        </li>
                        <li>
                          <button
                            class="btn btn-sm mx-4 btn-primary float-end"
                            @click="
                              onBoarding.step3.tabId = 3;
                              $modal.hide('Errors');
                            "
                          >
                            {{ $t("lang.orders.fix_it") }}
                          </button>
                        </li>
                      </div>
                    </div>
                  </div>
                  <div
                    class="card mt-2"
                    v-if="
                      isActivationOrder &&
                        onBoarding.activationContactsCount > 0 &&
                        onBoarding.activationContactsWithEmailCount < 1
                    "
                  >
                    <div class="card-header mb-0" id="headingActivationEmail">
                      <h5 class="mb-0">
                        <button
                          class="btn btn-link collapsed"
                          data-toggle="collapse"
                          data-target="#collapseActivationEmail"
                          aria-expanded="false"
                          aria-controls="collapseActivationEmail"
                        >
                          {{ $t("lang.orders.your_targeting") }}
                        </button>
                      </h5>
                    </div>
                    <div
                      id="collapseActivationEmail"
                      class="collapse show"
                      aria-labelledby="headingActivationEmail"
                      data-parent="#accordion"
                    >
                      <div class="card-body">
                        <li class="list-group-item border-0">
                          <i class="icon-circle mr-1 text-danger"></i>
                          {{ $t("lang.orders.activation_import_validate_no_email") }}
                        </li>
                        <li>
                          <button
                            class="btn btn-sm mx-4 btn-primary float-end"
                            @click="
                              onBoarding.step3.tabId = 3;
                              $modal.hide('Errors');
                            "
                          >
                            {{ $t("lang.orders.fix_it") }}
                          </button>
                        </li>
                      </div>
                    </div>
                  </div>


                  <div
                    class="card"
                    v-if="
                      onBoarding.step3.updateSales.length == 0 &&
                        onBoarding.typeForm != 'onboarding'
                    "
                  >
                    <div class="card-header mb-0" id="headingTwo">
                      <h5 class="mb-0">
                        <button
                          class="btn btn-link collapsed"
                          data-toggle="collapse"
                          data-target="#collapseTwo"
                          aria-expanded="false"
                          aria-controls="collapseTwo"
                        >
                          {{ $t("lang.onBoarding.who_is_thesales") }}
                        </button>
                      </h5>
                    </div>
                    <div
                      id="collapseTwo"
                      class="collapse show"
                      aria-labelledby="headingTwo"
                      data-parent="#accordion"
                    >
                      <div class="card-body">
                        <li class="list-group-item border-0">
                          <i class="icon-circle mr-1 text-danger"></i>
                          {{ this.$t("lang.orders.unavailablesales") }}
                        </li>
                        <li>
                          <button
                            class="btn btn-sm mx-4 btn-primary float-end"
                            @click="
                              onBoarding.step3.tabId = 1;
                              $modal.hide('Errors');
                            "
                          >
                            {{ this.$t("lang.orders.fix_it") }}
                          </button>
                        </li>
                      </div>
                    </div>
                  </div>

                  <!-- Audience Description  -->
                  <!-- <div
                    class="card"
                    v-if="
                      (onBoarding.audience == '' ||
                        onBoarding.audience_description == '') &&
                        onBoarding.typeForm != 'onboarding' &&
                        (currentUser.role_id == 1 || currentUser.role_id == 5)
                    "
                  >
                    <div class="card-header mb-0" id="headingTwo">
                      <h5 class="mb-0">
                        <button
                          class="btn btn-link collapsed"
                          data-toggle="collapse"
                          data-target="#collapseTwo"
                          aria-expanded="false"
                          aria-controls="collapseTwo"
                        >
                          Audience And Audience Description
                        </button>
                      </h5>
                    </div>
                    <div
                      id="collapseTwo"
                      class="collapse show"
                      aria-labelledby="headingTwo"
                      data-parent="#accordion"
                    >
                      <div class="card-body">
                        <li
                          class="list-group-item border-0"
                          v-if="onBoarding.audience == ''"
                        >
                          <i class="icon-circle mr-1 text-danger"></i>
                          The audience cannot be empty
                        </li>
                        <li
                          class="list-group-item border-0"
                          v-if="onBoarding.audience_description == ''"
                        >
                          <i class="icon-circle mr-1 text-danger"></i>
                          The audience description cannot be empty
                        </li>
                        <li>
                          <button
                            class="btn btn-sm mx-4 btn-primary float-end"
                            @click="
                              onBoarding.step3.tabId = 1;
                              $modal.hide('Errors');
                            "
                          >
                            {{ this.$t("lang.orders.fix_it") }}
                          </button>
                        </li>
                      </div>
                    </div>
                  </div> -->
                  <!-- <div
                    class="card mt-4"
                    v-if="onBoarding.apollo.total_result <= 3000"
                  >
                    <div class="card-header mb-0" id="headingTwo">
                      <h5 class="mb-0">
                        <button
                          class="btn btn-link collapsed"
                          data-toggle="collapse"
                          data-target="#collapseTwo"
                          aria-expanded="false"
                          aria-controls="collapseTwo"
                        >
                          {{ $t("lang.onBoarding.what_are_your_targets") }}
                        </button>
                      </h5>
                    </div>
                    <div
                      id="collapseTwo"
                      class="collapse show"
                      aria-labelledby="headingTwo"
                      data-parent="#accordion"
                    >
                      <div class="card-body">
                        <li class="list-group-item border-0">
                          <i class="icon-circle mr-1 text-danger"></i>
                          {{ this.$t("lang.orders.too_low") }}
                          <button
                              class="btn btn-sm btn-primary float-right ml-2"
                              @click="goToSubStep(2, 1)"
                              v-if="!simplify"
                            >
                              {{ $t("lang.onBoarding.gotostep", { step: "" }) }}
                            </button>
                        </li>
                        <li>
                          <button
                            class="btn btn-sm mx-4 btn-primary float-end"
                            @click="
                              onBoarding.step3.tabId = 3;
                              $modal.hide('Errors');
                            "
                          >
                            {{ this.$t("lang.orders.fix_it") }}
                          </button>
                        </li>
                      </div>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>

    <!-- Modal Tarjeta de credito -->
    <Modal :name="'confirm'" v-if="!loading" :size="'35'" :max-width="'350'">
      <div class="p-4 text-center">
        <h5 class="card-title text-left text-primary mb-2">
          {{ $t("lang.onBoarding.card_title") }}
        </h5>
        <div class="row my-3">
          <div class="col-8 text-left">
            <ul>
              <li>
                <i
                  class="icon-check-circle cursor-pointer text-success mr-2"
                ></i>
                <small>{{ $t("lang.onBoarding.card_list1") }}</small>
              </li>
              <li>
                <i
                  class="icon-check-circle cursor-pointer text-success mr-2"
                ></i>
                <small>{{ $t("lang.onBoarding.card_list2") }}</small>
              </li>
              <li>
                <i
                  class="icon-check-circle cursor-pointer text-success mr-2"
                ></i>
                <small>{{ $t("lang.onBoarding.card_list3") }}</small>
              </li>
              <li>
                <i
                  class="icon-check-circle text-success cursor-pointer mr-2"
                ></i>
                <small>{{ $t("lang.onBoarding.card_list4") }}</small>
              </li>
            </ul>
          </div>
          <div class="col-4 d-flex justify-content-end align-items-center">
            <img
              width="30px"
              class="mr-2"
              src="@/assets/images/visa-logo.png"
            />
            <img width="30px" class="mr-2" src="@/assets/images/mc-logo.png" />
            <img width="30px" class="mr-2" src="@/assets/images/cb-logo.png" />
            <img width="30px" class="mr-2" src="@/assets/images/sepa.png" />
          </div>
        </div>
        <div class="row">
          <div class="col-12 m-0 p-0">
            <CreditCardForm
              ref="creditCardForm"
              :confirmPayment="false"
              :showSaveButton="true"
              :showPrincipal="false"
              :profileData="true"
              @refreshPaymentMethods="refreshPaymentMethods"
              @closeCreditCardModal="closeCreditCardModal"
            />
          </div>
        </div>
      </div>
    </Modal>

    <!-- Modal Aceptacion de videos y confirm checks -->
    <Modal :name="'videotraining'" :close="false">
      <div v-if="!training_step1" class="col-sm-8 offset-2">
        <h3 class="text-primary text-center">
          {{ $t("lang.training.title") }}
        </h3>

        <p class="text-center">{{ $t("lang.training.descripcion") }}</p>
        <div class="text-center text-dark mt-2 mb-2">
          <h5>{{ $t("lang.training.step2_3") }}</h5>
        </div>

        <div class="embed-responsive embed-responsive-16by9">
          <VideoToolToy :url="$t('lang.training.video_1')" :autoplay="true" />
        </div>
        <div class="text-center mb-5">
          <button
            class="btn cursor-pointer font-weight-bolder btn-sm btn-primary mr-5 m-1 mt-2 px-4"
            v-on:click="training_step1 = true"
          >
            {{ $t("lang.training.step1_button") }}
          </button>
        </div>
      </div>
      <div v-else class="col-sm-8 offset-2">
        <h3 class="text-primary text-center">
          {{ $t("lang.training.title") }}
        </h3>

        <p class="text-center">{{ $t("lang.training.descripcion") }}</p>
        <div class="text-center text-dark mt-2 mb-2">
          <h5>{{ $t("lang.training.step2_3") }}</h5>
        </div>

        <div class="embed-responsive embed-responsive-16by9">
          <VideoToolToy :url="$t('lang.training.video_2')" :autoplay="true" />
        </div>

        <div>
          <div class="mt-2 mb-5 d-flex flex-column">
            <div class="text-secondary">
              <input
                class="d-inline mr-2 mt-2 cursor-pointer"
                type="checkbox"
                v-model="training_check"
              />
              {{ $t("lang.training.term_1") }}
              <a
                target="_blank"
                class="text-primary"
                href="https://help.oliverlist.com/knowledge/signalement-des-rendez-vous-hors-scope"
                >{{ $t("lang.training.term_1_link") }}</a
              >
            </div>
            <div class="text-secondary">
              <input
                class="d-inline mr-2 mt-2 cursor-pointer"
                type="checkbox"
                v-model="trainingCheck_2"
              />
              {{ $t("lang.training.term_1") }}
              <a
                target="_blank"
                class="text-primary"
                href="https://help.oliverlist.com/knowledge/signalement-des-rendez-vous-absents"
                >{{ $t("lang.training.term_2_link") }}</a
              >
            </div>
            <div class="text-secondary">
              <input
                class="d-inline mr-2 mt-2 cursor-pointer"
                type="checkbox"
                v-model="trainingCheck_3"
              />
              {{ $t("lang.training.term_3") }}
            </div>
          </div>
          <div class="text-center mb-5">
            <button
              class="btn cursor-pointer font-weight-bolder btn-sm btn-primary mr-5 m-1 mt-2 px-4"
              v-on:click="trainingPass()"
            >
              {{ $t("lang.training.step2_button") }}
            </button>
          </div>
        </div>
      </div>
    </Modal>

    <!-- Modal ContractConfirmation -->
    <Modal
      :name="'contractConfirmation'"
      :close="false"
      :clickToClose="false"
      :size="'50'"
      id="modalContact"
    >
      <div class="row px-4 py-4">
        <div class="col-12 text-center mb-4">
          <h4>Timeline</h4>
        </div>
        <div class="col-12">
          <ul>
            <li>
              <div class="row">
                <div class="col-2 justify-content-start">
                  <div
                    class="row justify-content-content align-items-center flex-column"
                  >
                    <div
                      class="d-flex flex-column align-items-center justify-content-center text-primary p-0"
                    >
                      <div class="row">
                        <div class="col-5 mr-1 border-custom-right-hide"></div>
                        <div class="col-6"></div>
                      </div>
                    </div>
                    <div
                      class="d-flex justify-content-center align-items-center bg-ligth pt-2"
                      style="
                        border-radius: 100%;
                        width: 70px;
                        height: 70px;
                        border: 6px solid blue;
                      "
                    >
                      <h5><strong>D+0</strong></h5>
                    </div>
                    <div
                      class="d-flex flex-column align-items-center justify-content-center text-primary p-0"
                    >
                      <div class="row">
                        <div class="col-5 mr-1 border-custom-right"></div>
                        <div class="col-6"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-10 pl-0 mt-4">
                  <h5 class="text-primary font-weight-bold">
                    {{ $t("lang.orders.timeline_sending") }}
                  </h5>
                  <p>
                    {{ $t("lang.orders.timeline_sending_detail") }}
                  </p>
                </div>
              </div>
            </li>
            <!-- First order validation -->
            <li>
              <div class="row">
                <div class="col-2">
                  <div
                    class="row justify-content-content align-items-center flex-column"
                  >
                    <div
                      class="d-flex flex-column align-items-center justify-content-center text-primary p-0"
                    >
                      <div class="row">
                        <div class="col-5 mr-1 border-custom-right"></div>
                        <div class="col-6"></div>
                      </div>
                    </div>
                    <div
                      class="d-flex justify-content-center text-white align-items-center bg-primary pt-2 circle-custom"
                    >
                      <h5><strong>D+1</strong></h5>
                    </div>
                    <div
                      class="d-flex flex-column align-items-center justify-content-center text-primary p-0"
                    >
                      <div class="row">
                        <div class="col-5 mr-1 border-custom-right"></div>
                        <div class="col-6"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-10 pl-0 mt-4">
                  <h5 class="text-primary font-weight-bold">
                    {{ $t("lang.orders.timeline_first") }}
                  </h5>
                  <p>
                    {{ $t("lang.orders.timeline_first_detail") }}
                  </p>
                </div>
              </div>
            </li>
            <!-- Account configuration -->
            <li>
              <div class="row">
                <div class="col-2">
                  <div
                    class="row justify-content-content align-items-center flex-column"
                  >
                    <div class="row">
                      <div class="col-5 mr-1 border-custom-right"></div>
                      <div class="col-6"></div>
                    </div>
                    <div
                      class="d-flex justify-content-center text-white align-items-center bg-primary pt-2 circle-custom"
                    >
                      <h5><strong>D+2</strong></h5>
                    </div>
                    <div
                      class="d-flex flex-column align-items-center justify-content-center text-primary p-0"
                    >
                      <div class="row">
                        <div class="col-5 mr-1 border-custom-right"></div>
                        <div class="col-6"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-10 pl-0 mt-4">
                  <h5 class="text-primary font-weight-bold">
                    {{ $t("lang.orders.timeline_configuration") }}
                  </h5>
                  <p>
                    {{ $t("lang.orders.timeline_configuration_detail") }}
                  </p>
                </div>
              </div>
            </li>
            <!-- Launching -->
            <li>
              <div class="row">
                <div class="col-2">
                  <div
                    class="row justify-content-content align-items-center flex-column"
                  >
                    <div class="row">
                      <div class="col-5 mr-1 border-custom-right"></div>
                      <div class="col-6"></div>
                    </div>
                    <div
                      class="d-flex justify-content-center text-white align-items-center bg-primary pt-2 circle-custom"
                    >
                      <h5><strong>D+15</strong></h5>
                    </div>
                    <div
                      class="d-flex flex-column align-items-center justify-content-center text-primary p-0"
                    ></div>
                  </div>
                </div>
                <div class="col-10 pl-0 mt-4">
                  <h5 class="text-primary font-weight-bold">
                    {{ $t("lang.orders.timeline_launching") }}
                  </h5>
                  <p>
                    {{ $t("lang.orders.timeline_launching_detail") }}
                  </p>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <!-- <div class="col-7">texto texto.. </div> -->
        <div class="col-12 pt-4 pb-0 text-center">
          <button
            class="btn cursor-pointer font-weight-bolder btn-sm btn-primary mr-5 m-1 mt-2 px-4"
            @click="modalContractConfirmation('yes')"
          >
            {{ $t("lang.button.yes") }}
          </button>
          <button
            class="btn cursor-pointer font-weight-bolder btn-sm btn-danger mr-5 m-1 mt-2 px-4"
            @click="modalContractConfirmation('hide')"
          >
            {{ $t("lang.button.cancel") }}
          </button>
        </div>
      </div>
    </Modal>

    <LoadingSpinner v-if="isCopyTarget" />


    <div class="col-12 mb-3" v-else>
      <div class="row">
        <!-- Order name -->
        <div class="col-12 mb-2">
          <h4 class="d-inline text-primary card-title mb-4">
            <strong>{{ $t("lang.onBoarding.your_order") }}:</strong>
          </h4>

          <span v-if="!isOpen('orderName')" class="border-0 pl-0 ml-2">
            {{ onBoarding.orderName }}
          </span>
          <span v-else-if="isOpen('orderName') && !disabledEdit()">
            <input
              min="1"
              max="100"
              class="text-primary mx-2 text-center border border-ligth"
              :value="onBoarding.orderName"
              :style="{ width: (onBoarding.orderName.length) + 'ch' }"
              @input="changeOrderName"
            />
          </span>
          <button
            class="ml-3 btn rounded-circle cursor-pointer btn-sm d-inline"
            style="background-color: #e3e3e3"
            type="button"
            v-if="!isOpen('orderName') && !disabledEdit()"
            @click="openEdit('orderName')"
          >
            <i class="icon-pencil"></i>
          </button>
          <button
            v-if="isOpen('orderName')"
            @click="closeEdit('orderName')"
            class="ml-1 btn cursor-pointer btn-sm btn-success d-inline"
            type="button"
          >
            <i class="icon-check1"></i> {{ $t("lang.button.save") }}
          </button>

          <button
            v-if="
              onBoarding.orderdata &&
                onBoarding.orderdata.client_id &&
                hasPermissions('superAdmin')
            "
            @click="goToClient(onBoarding.orderdata.client_id)"
            class="btn btn-primary mx-4 btn-sm"
          >
            Client link
          </button>
          <button
            v-if="
              onBoarding.orderdata &&
                onBoarding.orderdata.client_id &&
                hasPermissions('superAdmin') &&
                (targetId || onBoarding.orderId)
            "
            class="btn btn-primary btn-sm"
            :disabled="loadingOrderDataExport"
            @click="exportOrderData"
          >
            <span v-if="!loadingOrderDataExport">Campaign data export</span>
            <span v-else>Processing...</span>
          </button>
        </div>

        <!-- buttons for admins -->
        <div class="col-12 pl-2">
          <div class="float-left">
            <!-- save -->
            <button
              class="btn cursor-pointer font-weight-bolder btn-sm btn-primary m-1 mt-2 px-4"
              :disabled="saving"
              type="button"
              @click="savenow(false, false)"
              v-if="
                !disabledEdit() ||
                  (this.currentUser.role_id == 1 &&
                    this.onBoarding.step3.tabId == 4)
              "
            >
              {{ $t("lang.button.save") }}
              <span
                v-if="saving"
                class="loadingres mr-1 ml-1 spinner-border loading-spinner text-white"
              ></span>
            </button>

			      <!-- Stop Sending 48 hrs -->
            <button
              v-if="
                !onBoarding.isMonthlyPaused &&
                  onBoarding.hoursPaused < 36 &&
                  onBoarding.orderId &&
                  !addOrder &&
                  target_status_id == 4
                  && currentUser.role_id != 4
              "
              class="btn font-weight-bolder btn-sm btn-secondary m-1 mt-2 px-4"
              type="button"
              @click="stopSendingForThisMonth(48)"
            >
              {{ $t("lang.button.stopsendingfornhours", { hours: 48 }) }}
            </button>

			      <!-- Stop Sending for month -->
            <Tooltip
              v-if="
                !onBoarding.isMonthlyPaused &&
                  onBoarding.orderId &&
                  !addOrder &&
                  target_status_id == 4
              "
              :text="
                availableStopSendingForThisMonth
                  ? ''
                  : $t('lang.label.stopsendingforthismonthdisable')
              "
              :width="''"
            >
              <button
                v-if="onBoarding.orderId && !addOrder && target_status_id == 4 && currentUser.role_id != 4"
                class="btn font-weight-bolder btn-sm btn-secondary m-1 mt-2 px-4"
                type="button"
                @click="stopSendingForThisMonth()"
              >
                {{ $t("lang.button.stopsendingforthismonth") }}
              </button>
            </Tooltip>

			      <!-- duplicate -->
            <button
              v-if="onBoarding.orderId && !addOrder && currentUser.role_id != 4"
              class="btn cursor-pointer font-weight-bolder btn-sm btn-dark m-1 mt-2 px-4"
              type="button"
              @click="duplicate()"
            >
              {{ $t("lang.campaigns_dashboard.copycampaign") }}
            </button>

            <!-- soumetreer button in draft target -->
            <button
              v-if="
                canSubmitForValidation &&
                  onBoarding.orderId &&
                  onBoarding.target_status_id == 3
              "
              class="btn cursor-pointer font-weight-bolder btn-sm btn-primary m-1 mt-2 px-4"
              :disabled="saving"
              type="button"
              @click="validate()"
            >
              {{ $t("lang.onBoarding.start_preparing_my_campaigns") }}
              <span
                v-if="saving"
                class="loadingres mr-1 ml-1 spinner-border loading-spinner text-primary"
              ></span>
            </button>


			      <button
              v-if="
                  parseInt(target_status_id) == 3
              "
              class="btn cursor-pointer font-weight-bolder btn-sm btn-warning m-1 mt-2 px-4"
              type="button"
              @click="changeStatus(5)"
            >
              {{ $t("lang.campaigns_dashboard.archivecampaign") }}
            </button>

			      <!-- stopped red -->
            <button
              v-if="
                (parseInt(target_status_id) == 1 ||
                  parseInt(target_status_id) == 4) &&
                  hasPermissions('adminAgency') &&
                  !addOrder
              "
              class="btn cursor-pointer font-weight-bolder btn-sm btn-danger m-1 mt-2 px-4"
              type="button"
              @click="changeStatus(2)"
            >
              {{ $t("lang.button.stop") }}
            </button>
          </div>
        </div>
        <!-- Switch / Close order -->
        <!-- <div
          class="col-6 pr-4 py-0 my-0"
          v-if="
            hasPermissions('superAdminTargets') &&
            onBoarding.validationTarget.status == 1
          "
        >
          <div class="float-right">
            <vue-form-generator
              :schema="schemaCloseOrder"
              :model="onBoarding"
              @model-updated="saveOrderClosed()"
            >
            </vue-form-generator>
          </div>
        </div> -->
      </div>

      <!-- Definition Component Tabs -->
      <Tabs
        :tabs="tabs1"
        @change="changeTabStep3($event)"
        :tabSelected="onBoarding.step3.tabId"
      />

      <!-- Tab - Parameters -->
      <div class="col-12 px-3" v-if="onBoarding.step3.tabId == 1">
        <!-- Option -> Status -->
        <div class="row my-1 mb-3 px-2">
          <div class="col-12">
            <small class="mr-3">{{ $t("lang.column.status") }}:</small>
            <div class="d-inline" v-if="target_status_id == 1">
              <span class="badge badge-primary text-white px-3 py-2">
                {{ $t("lang.targets.active") }}
              </span>
              <Tooltip
                :text="$t('lang.orders.status_prepare_tooltip')"
                :width="''"
              >
                <div
                  class="ml-3 mt-3 circle bg-secondary d-flex align-items-center justify-content-center"
                >
                  <div class="question-mark text-white">?</div>
                </div>
              </Tooltip>
            </div>

            <div class="d-inline" v-if="target_status_id == 2">
              <span class="badge badge-danger text-white px-3 py-2">
                {{ $t("lang.targets.stopped") }}</span
              >
              <Tooltip
                :text="$t('lang.orders.status_inactive_tooltip')"
                :width="''"
              >
                <div
                  class="ml-3 mt-3 circle bg-secondary d-flex align-items-center justify-content-center"
                >
                  <div class="question-mark text-white">?</div>
                </div>
              </Tooltip>
            </div>

            <div class="d-inline" v-if="target_status_id == 3">
              <span class="badge badge-secondary text-white px-3 py-2">
                {{ $t("lang.targets.pending") }}</span
              >
              <Tooltip
                :text="$t('lang.orders.status_draft_tooltip')"
                :width="''"
              >
                <div
                  class="ml-3 mt-3 circle bg-secondary d-flex align-items-center justify-content-center"
                >
                  <div class="question-mark text-white">?</div>
                </div>
              </Tooltip>
            </div>

            <div class="d-inline" v-if="target_status_id == 4">
              <span class="badge badge-success text-white px-3 py-2">
                {{ $t("lang.targets.running") }}</span
              >
              <span
                class="badge badge-danger text-white px-3 py-2 ml-2"
                v-if="onBoarding.isMonthlyPaused"
              >
                {{ $t("lang.targets.monthlypaused") }}</span
              >
              <span
                class="badge badge-danger text-white px-3 py-2 ml-2"
                v-if="onBoarding.hoursPaused > 0"
              >
                {{
                  $t("lang.targets.nhourspaused", {
                    hours: onBoarding.hoursPaused
                  })
                }}</span
              >
              <Tooltip
                :text="$t('lang.orders.status_active_tooltip')"
                :width="''"
              >
                <div
                  class="ml-3 mt-3 circle bg-secondary d-flex align-items-center justify-content-center"
                >
                  <div class="question-mark text-white">?</div>
                </div>
              </Tooltip>
            </div>

            <div class="d-inline" v-if="target_status_id == 5">
              <span class="badge badge-warning text-white px-3 py-2">
                {{ $t("lang.targets.archived") }}</span
              >
              <Tooltip
                :text="$t('lang.orders.status_achived_tooltip')"
                :width="''"
              >
                <div
                  class="ml-3 mt-3 circle bg-secondary d-flex align-items-center justify-content-center"
                >
                  <div class="question-mark text-white">?</div>
                </div>
              </Tooltip>
            </div>
          </div>
        </div>

        <!-- Option -> Language -->
        <div class="row my-2 px-2">
          <div class="col-12">
            <small for="staticEmail" class=" mr-4">
              {{ $t("lang.label.language") }}:
            </small>
            <button
              type="button"
              @click="showFlag = true"
              :disabled="true"
              class="btn btn-light px-0 py-0 my-0 mx-0"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <span
                class="input-group-text px-1 py-1"
                style="background-color: white"
              >
                {{ getLangSelected }}
                <img
                  width="25"
                  :src="flagActually(null)"
                  class="flag ml-3 mr-2"
                />
              </span>
            </button>

            <div class="dropdown-menu dropdown-menu-left">
              <button
                v-for="(lang, i) of langs"
                class="dropdown-item"
                type="button"
                :key="i"
                @click="changeLanguage(i)"
              >
                <div class="row">
                  <div class="col-8">
                    <span class="ml-0 small">{{ lang.label }}</span>
                  </div>
                  <div class="col-4">
                    <img
                      :src="flagActually(lang.id)"
                      class="flag2 mr-3"
                      width="25"
                    />
                  </div>
                </div>
              </button>
            </div>
          </div>
        </div>

        <!-- Option -> Order type -->
        <div class="row my-2 px-2">
          <div class="col-12">
            <small class="mr-3">{{ $t("lang.orders.order_type") }}:</small>
            <select
              class="d-inline form-control w-auto"
              :value="onBoarding.order_type"
              :disabled="orderTypeLocked"
              @change="onOrderTypeChange($event)"
            >
              <option value="acquisition">
                {{ $t("lang.orders.order_type_acquisition") }}
              </option>
              <option value="activation">
                {{ $t("lang.orders.order_type_activation") }}
              </option>
            </select>
            <small
              v-if="orderTypeLockMessage"
              class="d-block text-muted mt-1"
            >
              {{ orderTypeLockMessage }}
            </small>
          </div>
        </div>

        <!-- Option -> Appointment Volume -->
        <div class="row my-2 px-2">
          <div class="col-12">
            <small v-if="!isOpen('appointment')" class="mr-4">
              <span class="mr-4 ">
                {{ $t("lang.onBoarding.expected_value_appointments") }}:
                <Tooltip
                  :text="$t('lang.orders.meet_month_tooltip')"
                  :width="''"
                >
                  <div
                    class="ml-3 mt-3 circle bg-secondary d-flex align-items-center justify-content-center"
                  >
                    <div class="question-mark text-white">?</div>
                  </div>
                </Tooltip>
              </span>
              <b class="text-primary">{{
                onBoarding.step3.appointmentVolume
              }}</b>
              /
              {{ $t("lang.label.month") }}
            </small>
            <span
              v-else-if="isOpen('appointment') && !disabledEdit()"
              class="font-weight-bold mr-4"
            >
              <small class="bg-white border-0 pl-0"
                >{{ $t("lang.onBoarding.expected_value_appointments") }}
              </small>
              <span class="mx-4">
                <div class="wrapper">
                  <input
                    min="10"
                    max="100"
                    class="form-control"
                    type="number"
                    v-model="onBoarding.step3.appointmentVolume"
                    @input="changeAppointmentVolume"
                  />
                </div>
              </span>

              <small class="bg-white border-0 pl-0 pt-0">
                / {{ $t("lang.label.month") }}
              </small>
            </span>

            <button
              class="ml-1 btn rounded-circle cursor-pointer btn-sm d-inline"
              style="background-color: #e3e3e3"
              type="button"
              v-if="!isOpen('appointment') && !disabledEdit()"
              @click="openEdit('appointment')"
            >
              <i class="icon-pencil"></i>
            </button>
            <button
              v-if="isOpen('appointment')"
              @click="closeEdit('appointment')"
              :disabled="
                onBoarding.step3.appointmentVolume == '' ||
                  formValidation.appointment
              "
              class="ml-1 btn cursor-pointer btn-sm btn-success d-inline"
              type="button"
            >
              <i class="icon-check1"></i> {{ $t("lang.button.save") }}
            </button>
          </div>
          <div class="col-12 my-0 py-0">
            <span v-if="formValidation.appointment" class="text-danger">{{
              $t("lang.orders.appointment_invalid")
            }}</span>
          </div>
        </div>

        <!-- Option -> Launch Date -->
        <div class="row my-2 px-2">
          <div class="col-12">
            <small v-if="!isOpen('launchDate')">
              <span class="mr-4 ">
                {{ $t("lang.onBoarding.launch_date_campaign") }}:
                <i class="text-danger">*</i>
                <Tooltip
                  :text="$t('lang.orders.start_send_tooltip')"
                  :width="''"
                >
                  <div
                    class="ml-3 mt-3 circle bg-secondary d-flex align-items-center justify-content-center"
                  >
                    <div class="question-mark text-white">?</div>
                  </div>
                </Tooltip>
              </span>
              <span v-if="onBoarding.step3.launchDate == '' || onBoarding.step3.launchDate == undefined"
              class="loadingres mr-2 ml-2 spinner-border loading-spinner"></span>
              <span v-else>
                {{ onBoarding.step3.launchDate.substr(0, 10) }}
              </span>
            </small>
            <small v-else-if="isOpen('launchDate')">
              <span class="bg-white border-0 pl-0"
                >{{ $t("lang.onBoarding.launch_date_campaign") }}:
              </span>
              <vue-form-generator
                class="d-inline-block mx-4"
                ref="launchDateForm"
                :schema="schemaStatus"
                :model="modelform"
                :options="formOptions"
              ></vue-form-generator>
            </small>
            <button
              class="ml-4 btn rounded-circle cursor-pointer btn-sm border-0"
              style="background-color: #e3e3e3"
              :class="onBoarding.step3.launchDate ? '' : 'bg-danger'"
              type="button"
              v-if="!isOpen('launchDate') && !disabledEdit()"
              @click="openEdit('launchDate')"
            >
              <i class="icon-pencil"></i>
            </button>
            <button
              v-if="isOpen('launchDate')"
              @click="changeLaunchDate()"
              :disabled="
                onBoarding.step3.launchDate == '' ||
                  ($refs.launchDateForm !== undefined &&
                    $refs.launchDateForm.errors.length > 0)
              "
              class="ml-1 btn cursor-pointer btn-sm btn-success"
              type="button"
            >
              <i class="icon-check1"></i> {{ $t("lang.button.save") }}
            </button>
          </div>
        </div>

        <!-- Option -> Price -->
        <div class="row my-2 px-2">
          <div class="col-12">
            <small v-if="!isOpen('editingAppointPrice')">
              <span class="mr-4 "
                >{{ $t("lang.onBoarding.my_price_appointment") }}:
                <Tooltip :text="$t('lang.onBoarding.not_taxes')" :width="''">
                  <div
                    class="ml-3 mt-3 circle bg-secondary d-flex align-items-center justify-content-center"
                  >
                    <div class="question-mark text-white">?</div>
                  </div>
                </Tooltip>
              </span>


              <span>
                {{ onBoarding.step3.appointmentPrice }} € /
                {{ $t("lang.label.meeting") }}
              </span>
              <b class="text-primary ml-1" v-if="false">
                ({{
                  $t("lang.onBoarding.prospects", {
                    prospects: new Intl.NumberFormat("es-ES").format(
                      onBoarding.apollo.total_result
                    )
                  })
                }})
              </b>
            </small>
            <small v-else-if="isOpen('editingAppointPrice') && !disabledEdit()">
              <span class="bg-white border-0 pl-0"
                >{{ $t("lang.onBoarding.my_price_appointment") }}
              </span>

              <span class="mx-2">
                <div class="wrapper">
                  <input
                    min="1"
                    max="500"
                    class="form-control"
                    type="number"
                    :value="onBoarding.step3.appointmentPrice"
                    @input="changeAppointmentPrice"
                  />
                </div>
              </span>
            </small>

            <button
              class="ml-1 btn rounded-circle cursor-pointer btn-sm btn-secondary d-inline"
              type="button"
              v-if="
                !isOpen('editingAppointPrice') &&
                  hasPermissions('superAdminTargets') &&
                  simplify &&
                  !disabledEdit()
              "
              @click="openEdit('editingAppointPrice')"
            >
              <i class="icon-pencil"></i>
            </button>
            <button
              v-if="isOpen('editingAppointPrice')"
              @click="closeEdit('editingAppointPrice')"
              class="ml-1 btn cursor-pointer btn-sm btn-success d-inline"
              type="button"
            >
              <i class="icon-check1"></i> {{ $t("lang.button.save") }}
            </button>
            <div
              class="row my-2"
              v-if="
                hasPermissions('superAdminTargets') &&
                  onBoarding.target_status_id == 1
              "
            >
              <div class="col-12">
                Verified:
                <small
                  v-if="!isOpen('verified')"
                  class="text-primary bg-white border-0 pl-0"
                >
                  {{ verificationOrder.label }}
                </small>
                <small v-else-if="isOpen('verified')">
                  <StatusComment
                    :status="verificationOrder.status"
                    :comments="verificationOrder.comment"
                    @onChange="changeVerificateOrder(...arguments)"
                  />
                </small>
                <button
                  class="ml-1 btn rounded-circle cursor-pointer btn-sm btn-secondary d-inline"
                  type="button"
                  v-if="
                    (!isOpen('verified') && !disabledEdit()) ||
                      currentUser.role_id == 1
                  "
                  @click="openEdit('verified')"
                >
                  <i class="icon-pencil"></i>
                </button>
                <button
                  v-if="isOpen('verified')"
                  @click="verificateOrder()"
                  class="ml-1 btn rounded-circle cursor-pointer btn-sm btn-success d-inline"
                  type="button"
                >
                  <i class="icon-check1"></i>
                </button>
              </div>
              <!-- aqui va estatus -->
            </div>
          </div>
        </div>

        <!-- Option -> New Emails per day -->
        <div class="row my-2 px-2" v-if="hasPermissions('superAdminTargets')">
          <div class="col-12">
            <small v-if="!isOpen('editingNewEmailsPerDay')">
              <span class="mr-4 ">{{ $t("lang.column.budgetday") }}: </span>

              <span class="ml-2">{{ onBoarding.step3.newEmailsPerDay }} </span>

              <button
                class="ml-1 btn rounded-circle cursor-pointer btn-sm btn-secondary d-inline"
                type="button"
                v-if="
                  !isOpen('editingNewEmailsPerDay') &&
                    simplify &&
                    !disabledEdit()
                "
                @click="openEdit('editingNewEmailsPerDay')"
              >
                <i class="icon-pencil"></i>
              </button>
            </small>

            <small
              v-else-if="isOpen('editingNewEmailsPerDay') && !disabledEdit()"
            >
              <span class="bg-white border-0 pl-0"
                >{{ $t("lang.column.budgetday") }}
              </span>

              <span class="mx-2">
                <div class="wrapper">
                  <input
                    min="1"
                    max="100"
                    class="form-control"
                    type="number"
                    :value="onBoarding.step3.newEmailsPerDay"
                    @input="changeNewEmailsPerDay"
                  />
                </div>
              </span>
              <button
                @click="closeEdit('editingNewEmailsPerDay')"
                class="ml-1 btn cursor-pointer btn-sm btn-success d-inline"
                type="button"
              >
                <i class="icon-check1"></i> {{ $t("lang.button.save") }}
              </button>
            </small>
          </div>
        </div>

        <!-- Option -> Total Emails per day -->
        <div class="row my-2 px-2" v-if="hasPermissions('superAdminTargets')">
          <div class="col-12">
            <small v-if="!isOpen('editingTotalEmailsPerDay')">
              <span class="mr-4 "
                >{{ $t("lang.column.totalbudgetday") }}:
              </span>

              <span class="ml-2"
                >{{ onBoarding.step3.totalEmailsPerDay }}
              </span>

              <button
                class="ml-1 btn rounded-circle cursor-pointer btn-sm btn-secondary d-inline"
                type="button"
                v-if="
                  !isOpen('editingTotalEmailsPerDay') &&
                    simplify &&
                    !disabledEdit()
                "
                @click="openEdit('editingTotalEmailsPerDay')"
              >
                <i class="icon-pencil"></i>
              </button>
            </small>

            <small v-else-if="isOpen('editingTotalEmailsPerDay')">
              <span class="bg-white border-0 pl-0"
                >{{ $t("lang.column.totalbudgetday") }}
              </span>

              <span class="mx-2">
                <div class="wrapper">
                  <input
                    min="1"
                    max="200"
                    class="form-control"
                    type="number"
                    :value="onBoarding.step3.totalEmailsPerDay"
                    @input="changeTotalEmailsPerDay"
                  />
                </div>
              </span>
              <button
                @click="closeEdit('editingTotalEmailsPerDay')"
                class="ml-1 btn cursor-pointer btn-sm btn-success d-inline"
                type="button"
              >
                <i class="icon-check1"></i> {{ $t("lang.button.save") }}
              </button>
            </small>
          </div>
        </div>
        <!-- Option -> DUPLICATE REASON ONLY OLIVER -->
        <div class="row my-2 px-2" v-if="currentUser.role_id == 1">
          <div class="col-12">
            <small v-if="!isOpen('duplicate_reason')" class="mr-4">
              <span class="mr-4 ">
                {{ $t("lang.onBoarding.duplicate_reason") }}:
                <Tooltip
                  :text="$t('lang.orders.meet_month_tooltip')"
                  :width="''"
                >
                  <div
                    class="ml-3 mt-3 circle bg-secondary d-flex align-items-center justify-content-center"
                  >
                    <div class="question-mark text-white">?</div>
                  </div>
                </Tooltip>
              </span>
              <b class="text-primary">{{ this.duplicate_reason }}</b>
            </small>
            <small
              v-else-if="isOpen('duplicate_reason') && !disabledEdit()"
              class="font-weight-bold mr-4"
            >
              <span class="bg-white border-0 pl-0"
                >{{ $t("lang.onBoarding.expected_value_appointments") }}
              </span>
              <span class="mx-4">
                <div class="wrapper">
                  <!-- select  reasons -->
                  <select
                    class="form-control"
                    v-model="onBoarding.step3.duplicate_reason"
                  >
                    <option value="A/B testing">A/B testing</option>
                    <option value="New order">New order</option>
                    <option value="Prospectors spin">Prospectors spin</option>
                    <option v-if="currentUser.role_id == 1" value="COM">COM</option>
                  </select>
                </div>
              </span>
            </small>

            <button
              class="ml-1 btn rounded-circle cursor-pointer btn-sm d-inline"
              style="background-color: #e3e3e3"
              type="button"
              v-if="!isOpen('duplicate_reason') && !disabledEdit()"
              @click="openEdit('duplicate_reason')"
            >
              <i class="icon-pencil"></i>
            </button>
            <button
              v-if="isOpen('duplicate_reason')"
              @click="closeEdit('duplicate_reason'), setDuplicateReason()"
              :disabled="duplicate_reason == ''"
              class="ml-1 btn cursor-pointer btn-sm btn-success d-inline"
              type="button"
            >
              <i class="icon-check1"></i> {{ $t("lang.button.save") }}
            </button>
          </div>
        </div>

        <!-- List the sales -->
        <div class="card px-4 mt-5" v-if="!simplify">
          <div class="card-title mt-3">
            <h5>
              {{ $t("lang.onBoarding.people_in_team_receiving_appointments") }}
            </h5>
          </div>
          <Tips
            :classCustom="'col-12'"
            :message="
              $t(
                'lang.onBoarding.step3_tip_1',
                this.$store.state.onboarding.lang
              )
            "
          />

          <div class="mt-3" v-if="typeForm == 'onboarding'">
            <TeamMembers @save="savenow(false, false)" />
          </div>
          <div
            v-if="targetingContactsTotal > 0 && !validSalesQuantity()"
            class="alert alert-danger"
            role="alert"
          >
            <div>
              <i class="mr-2 fas fa-solid fa-info-circle"></i>
              {{
                $t("lang.label.total_sale_suggest",
                {contacts_total: targetingContactsTotal,
                quantitySales: salesQuantity()})
              }}
            </div>
          </div>
        </div>
        <!-- <div class="card my-3 p-3" v-if="simplify || addOrder"> -->
        <LoadingSpinner v-if="loadingSales" />


        <div class="my-2 p-2" v-if="typeForm != 'onboarding'">

          <!-- Replace IndustrySearch.vue -->
          <div v-if="salesRep.length > 0 && currentUser.role_id != 4">
           <span> {{ $t("lang.onBoarding.who_is_thesales") }} </span>

           <div class="card p-2">
            <Fieldset :title="$t('lang.search.add')" mykey="who_is_thesales" :open="false">

                  <div v-for="item in salesRep" >
                    <div v-if="!isSelected(item.id)" class="d-inline-flex align-items-center p-1 mb-1" >
                      <button
                        class="btn btn-sm btn-primary mr-1"
                        @click="addSalesRep(item.id)"
                        >
                        <i class="icon-plus"></i>
                      </button>
                      <small>{{ item.label }} ({{ item.id }})</small>
                      <template v-for="totals in [salesInboxTotals(item)]">
                        <Tooltip :key="'active-' + item.id" class="ml-2 font-weight-bold" :text="'Total emails active'">
                          <small>{{ totals.active }} <i class="icon-circle text-success"></i></small>
                        </Tooltip>
                        <Tooltip :key="'warming-' + item.id" class="ml-2 font-weight-bold" :text="'Total emails in warming up'">
                          <small>{{ totals.warming_up }} <i class="icon-circle text-dark"></i></small>
                        </Tooltip>
                        <Tooltip :key="'stopped-' + item.id" class="ml-2 font-weight-bold" :text="'Total emails stopped'">
                          <small>{{ totals.stopped }} <i class="icon-circle text-danger"></i></small>
                        </Tooltip>
                        <Tooltip v-if="totals.not_first_sync" :key="'sync-' + item.id" class="ml-2 font-weight-bold" :text="'Total emails not first sync'">
                          <small>{{ totals.not_first_sync }} <i class="icon-refresh text-warning"></i></small>
                        </Tooltip>
                      </template>
                    </div>
                  </div>
            </Fieldset>





            <div class="card mt-2 p-2 border border-primary">
              <div v-if="selectedSalesRep.length > 0">
                <p class="mb-1">{{ $t("lang.column.selected") }}</p>
                <div v-for="item in selectedSalesRep" :key="item.id">
                  <div class="d-inline-flex align-items-center p-1 mb-1">
                    <span class="btn btn-sm btn-danger text-white cursor-pointer mr-1 px-2" @click="removeSales(item.id)">-</span>
                    <small>{{ item.label }} ({{ item.id }})</small>
                    <template v-for="totals in [salesInboxTotals(item)]">
                      <Tooltip :key="'sel-active-' + item.id" class="ml-2 font-weight-bold" :text="'Total emails active'">
                        <small>{{ totals.active }} <i class="icon-circle text-success"></i></small>
                      </Tooltip>
                      <Tooltip :key="'sel-warming-' + item.id" class="ml-2 font-weight-bold" :text="'Total emails in warming up'">
                        <small>{{ totals.warming_up }} <i class="icon-circle text-dark"></i></small>
                      </Tooltip>
                      <Tooltip :key="'sel-stopped-' + item.id" class="ml-2 font-weight-bold" :text="'Total emails stopped'">
                        <small>{{ totals.stopped }} <i class="icon-circle text-danger"></i></small>
                      </Tooltip>
                      <Tooltip v-if="totals.not_first_sync" :key="'sel-sync-' + item.id" class="ml-2 font-weight-bold" :text="'Total emails not first sync'">
                        <small>{{ totals.not_first_sync }} <i class="icon-refresh text-warning"></i></small>
                      </Tooltip>
                    </template>
                  </div>
                </div>
              </div>
              <div v-else class="text-muted">
                <small>{{ $t("lang.label.nosalesselected") }} ...</small>
              </div>
            </div>

            </div>
          </div>
          <div v-else>
            <small class="text-danger my-3" v-if="salesRep.length == 0">
              {{ $t("lang.orders.unavailablesales") }}
            </small>
          </div>
        </div>

        <div class="col-3 mb-3" v-if="hasPermissions('superAdmin')">
          Cold Call
          <treeselect
                v-model="shouldCcallTarget"
                :options="actionToCall"
                :clearable="false"
                :multiple="false"
                class="form-control inline-table"
              />
        </div>

        <div class="col-3 mb-3" v-if="hasPermissions('superAdmin') && !isSaleOrAccountExecutive">
          <span>Contact by SalesRidge</span>
          <treeselect
                v-model="contactSource"
                :options="contactSourceOptions"
                :clearable="false"
                :multiple="false"
                :disabled="contactSource == 1 ? true : false"
                class="form-control inline-table"
          />
        </div>

        <div class="col-12 mb-3" v-if="currentUser.role_id != 4">
              Bookers
              <treeselect
                :disabled="onBoarding.target_status_id != '4'"
                v-model="bdrsSelected"
                :options="bdr_users"
                :multiple="true"
                :clearable="false"
                :normalizer="normalizeOptions"
                class="form-control inline-table"
              />
        </div>
        <div class="col-3 mb-3" v-if="typeForm != 'onboarding' && !loading && currentUser.role_id != 4">
          Audience:
          <select
            v-if="!loading"
            v-model="categoryKey"
            class="d-inline form-control"
            :disabled="disabledEdit()"
            @change="setAudience(categoryKey)"
          >
            <option
              v-for="item in categories_jobs_group.filter(
                e => e.category != 'Custom_Job_Titles'
              )"
              :key="item.category"
              :value="item.category"
              class="optionSelect"
              :class="{
                'text-primary': item.category === 'Custom_Job_Titles',
                'font-weight-bold': item.category === 'Custom_Job_Titles'
              }"
            >
              {{ $t("lang.category_job_group." + item.category) }}
            </option>
          </select>
        </div>
        <div class="col-3 mb-3" v-if="typeForm != 'onboarding' && !loading && currentUser.role_id != 4">
          Audience description:
          <select
            v-if="!loading"
            v-model="audience_description"
            class="d-inline form-control"
            :disabled="disabledEdit()"
            @change="setAudienceDescription(audience_description)"
          >
            <option
              v-for="item in audience_items"
              :key="item"
              :value="item"
              class="optionSelect"
            >
              {{ item }}
            </option>
          </select>
        </div>

        <!-- Description -->
        <div class="col-12" v-if="currentUser.role_id != 4">
          {{ $t("lang.column.description") }}:
          <p>
            <textarea
              class="form-control"
              name=""
              rows="3"
              :disabled="disabledEdit()"
              :value="onBoarding.descriptionOrder"
              @input="changeDescriptionOrder"
            >
            </textarea>
          </p>
        </div>


        <!-- Cold call script specifications -->
        <div class="col-12 mt-3" v-if="hasPermissions('superAdmin')">
          <div class="d-flex align-items-center mb-1 ">
            <span>Cold call script specifications :</span>
            <button
              type="button"
              class="ml-2 btn btn-sm btn-primary"
              :disabled="disabledEdit() || generatingColdCallSpec"
              @click="generateColdCallSpecifications"
            >
              <span
                v-if="generatingColdCallSpec"
                class="spinner-border spinner-border-sm mr-1"
                role="status"
                aria-hidden="true"
              ></span>
              {{ $t("lang.onBoarding.generateColdCallSpecifications") }}
            </button>
          </div>
          <p>
            <textarea
              class="form-control"
              name=""
              rows="3"
              :disabled="disabledEdit()"
              :value="onBoarding.coldcallspec"
              @input="changeColdCallScriptSpecifications"
            >
            </textarea>
          </p>
        </div>
        <div
          class="col-6 mt-4"
          v-if="this.$store.state.authentication.user.role_id == 1 && !loading"
        >
          <div class="d-flex align-items-center form-group">
            <input
              type="checkbox"
              class=""
              :disabled="disabledEdit()"
              @change="updateActiveWarmup($event)"
              :checked="
                this.$store.state.onboarding.warmup_active == 1 ? true : false
              "
            />
            <small class="mt-1 ml-3 font-weight-bold" for=""
              >Activate warmup</small
            >
          </div>
        </div>
        <div
          class="col-6 mt-4"
          v-if="this.$store.state.authentication.user.role_id == 1 && !loading"
        >
          <div class="d-flex align-items-center form-group">
            <input
              type="checkbox"
              class=""
              :disabled="disabledEdit()"
              @change="updateCreateMailboxes($event)"
              :checked="
                this.$store.state.onboarding.create_mailboxes == 1 ? true : false
              "
            />
            <small class="mt-1 ml-3 font-weight-bold" for=""
              >{{ $t("lang.column.create_mailboxes") }}</small
            >
          </div>
        </div>
      </div>

      <!-- Tab - Services -->
      <div class="col-12 px-4 pt-2" v-if="onBoarding.step3.tabId == 2">
        <!-- Option > Company Name (input) -->
        <div class="row mx-1">
          <div class="col-12 d-flex justify-content-start px-0">
            <span class="d-flex align-items-end">
              {{
                $t(
                  "lang.onBoarding.step1_1_question",
                  this.$store.state.onboarding.lang
                )
              }}
              <i class="ml-1 text-danger">*</i>
            </span>
            <input
              class="w-50 text-primary flex-fill mt-2 mx-2 mb-1 lead pl-2 border-style-dashed text-size-14"
              maxlength="300"
              type="text"
              :value="onBoarding.productName"
              @input="changeProductName"
              :disabled="disabledEdit()"
              @focus="openEdit('productName')"
              @blur="closeEdit('productName')"
              :placeholder="
                $t(
                  'lang.onBoarding.example',
                  this.$store.state.onboarding.lang
                ) + ': Oliverlist'
              "
            />
          </div>
          <span class="col-12 text-center mt-2" v-if="isOpen('productName')">
            {{
              $t(
                "lang.label.charactersavailable",
                this.$store.state.onboarding.lang,
                { actual: onBoarding.productName.length, total: 150 }
              )
            }}
          </span>
        </div>
        <!-- Opction > Website (input)-->
        <div class="row px-3">
          <div class="col-12 d-flex justify-content-start px-0 py-0 my-0">
            <span class="d-flex align-items-end">
              {{
                $t(
                  "lang.onBoarding.step3_website",
                  this.$store.state.onboarding.lang
                )
              }}
              <i class="ml-1 text-danger">*</i>
            </span>
            <input
              @focus="editingUrl = true"
              @blur="editingUrl = false"
              class="w-50 text-primary flex-fill mt-2 mx-2 mb-1 lead pl-2 border-style-dashed text-size-14"
              maxlength="150"
              type="text"
              :value="onBoarding.website"
              @input="changeLink"
              :disabled="disabledEdit()"
              :placeholder="
                $t(
                  'lang.onBoarding.example',
                  this.$store.state.onboarding.lang
                ) + ': http://www.oliverlist.com'
              "
            />
          </div>
          <div v-if="editingUrl">
            <span
              class="text-muted my-0 py-0"
              v-if="onBoarding.website && onBoarding.disablednext"
            >
              {{
                $t("lang.ondemand.urlerror", this.$store.state.onboarding.lang)
              }}
              Example: https://www.oliverlist.com
            </span>
          </div>
        </div>
        <span class="col-12 text-center mt-2" v-if="editingUrl">
          {{
            $t(
              "lang.label.charactersavailable",
              this.$store.state.onboarding.lang,
              { actual: onBoarding.website.length, total: 150 }
            )
          }}
        </span>

        <!-- Opction > Offer prospect (select) -->
        <div class="mt-3">
          <span class="">
            {{
              $t(
                "lang.onBoarding.step1_3_question",
                this.$store.state.onboarding.lang
              )
            }}
            <i class="ml-1 text-danger">*</i>
          </span>

          <span class="ml-2">
            <select
              v-model="onBoarding.offer_prospect"
              class="d-inline form-control text-size-14"
              @change="changeOfferProspect"
              :disabled="disabledEdit()"
            >
              <option
                v-for="offer in select_offer_prospect"
                :key="offer.id"
                :value="offer.id"
                class="optionSelect"
              >
                {{ offer.label }}
              </option>
            </select>
          </span>
        </div>

        <!-- Opction > Description Sell (input) -->
        <div class="row px-3">
          <div class="col-12 d-flex justify-content-start px-0">
            <span class="d-flex align-items-end">
              {{
                $t(
                  "lang.onBoarding.description_sell_prepend",
                  this.$store.state.onboarding.lang
                ).replace("[]", this.$store.state.onboarding.productName)
              }}
              <i class="ml-1 text-danger">*</i>
            </span>
            <input
              class="w-50 text-primary flex-fill mt-2 mx-2 mb-1 lead pl-2 border-style-dashed text-size-14"
              maxlength="800"
              ref="inputOne"
              type="text"
              :value="onBoarding.descriptionSell"
              @input="changeDescriptionSell"
              :disabled="disabledEdit()"
              @focus="openEdit('descriptionSell')"
              @blur="changeDescriptionSellMinCharacter"
              :placeholder="getPlaceholder()"
            />
          </div>
        </div>
        <span class="col-12 text-center mt-2" v-if="isOpen('descriptionSell')">
          {{
            $t(
              "lang.label.charactersavailable",
              this.$store.state.onboarding.lang,
              { actual: onBoarding.descriptionSell.length, total: 800 }
            )
          }}
        </span>
        <!-- Opction > Avantages (text) -->
        <div class="mt-4">
          <span>
            <span class="">
              {{
                $t(
                  "lang.onBoarding.step1_6_question",
                  this.$store.state.onboarding.lang
                ).replace("[]", this.$store.state.onboarding.productName)
              }}
              <i class="ml-1 text-danger">*</i>
            </span>
          </span>

          <div class="col-12 mt-3">
            <div class="row">
              <div class="col-12 d-flex justify-content-start px-0">
                <span class="d-flex align-items-end">1.</span>
                <input
                  @focus="showMessage(5, 'enable', 0)"
                  @blur="showMessage(5, 'disable', 0)"
                  class="w-50 text-primary flex-fill mt-2 mx-2 mb-1 lead pl-2 border-style-dashed text-size-14"
                  maxlength="300"
                  type="text"
                  :disabled="disabledEdit()"
                  :value="getQuestionAnswer(5, 0)"
                  @input="changeQuestions($event, 5, 1)"
                  :placeholder="
                    $t(
                      'lang.onBoarding.step1_6_item_example1',
                      this.$store.state.onboarding.lang
                    )
                  "
                />
              </div>
              <p v-show="showInputMessage(5, 0)" class="text-left ml-4">
                {{ characterResponseCounter(5, 1, 300) }}
              </p>
            </div>
          </div>

          <div class="col-12 mt-3">
            <div class="row">
              <div class="col-12 d-flex justify-content-start px-0">
                <span class="d-flex align-items-end">2.</span>
                <input
                  @focus="showMessage(5, 'enable', 1)"
                  @blur="showMessage(5, 'disable', 1)"
                  class="w-50 text-primary flex-fill mt-2 mx-2 mb-1 lead pl-2 border-style-dashed text-size-14"
                  maxlength="300"
                  :disabled="disabledEdit()"
                  type="text"
                  :value="getQuestionAnswer(5, 1)"
                  @input="changeQuestions($event, 5, 2)"
                  :placeholder="
                    $t(
                      'lang.onBoarding.step1_6_item_example2',
                      this.$store.state.onboarding.lang
                    )
                  "
                />
              </div>
              <p v-show="showInputMessage(5, 1)" class="text-left ml-4">
                {{ characterResponseCounter(5, 2, 300) }}
              </p>
            </div>
          </div>

          <div class="col-12 mt-2">
            <div class="row">
              <div class="col-12 d-flex justify-content-start px-0">
                <span class="d-flex align-items-end">3.</span>
                <input
                  :disabled="disabledEdit()"
                  @focus="showMessage(5, 'enable', 2)"
                  @blur="showMessage(5, 'disable', 2)"
                  class="w-50 text-primary flex-fill mt-2 mx-2 mb-1 lead pl-2 border-style-dashed text-size-14"
                  maxlength="300"
                  type="text"
                  :value="getQuestionAnswer(5, 2)"
                  @input="changeQuestions($event, 5, 3)"
                  :placeholder="
                    $t(
                      'lang.onBoarding.step1_6_item_example3',
                      this.$store.state.onboarding.lang
                    )
                  "
                />
              </div>
              <p v-show="showInputMessage(5, 2)" class="text-left ml-4">
                {{ characterResponseCounter(5, 3, 300) }}
              </p>
            </div>
          </div>
        </div>
        <div class="mt-4">
          <span>
            <span class="">
              {{
                $t(
                  "lang.onBoarding.step1_7_question",
                  this.$store.state.onboarding.lang
                ).replace("[]", this.$store.state.onboarding.productName)
              }}
              <i class="ml-1 text-danger">*</i>
            </span>
          </span>

          <div class="col-12 mt-2">
            <div class="row">
              <div class="col-12 d-flex justify-content-start px-0">
                <span class="d-flex align-items-end">1.</span>
                <input
                  :disabled="disabledEdit()"
                  @focus="showMessage(6, 'enable', 0)"
                  @blur="showMessage(6, 'disable', 0)"
                  class="w-50 text-primary flex-fill mt-2 mx-2 mb-1 lead pl-2 border-style-dashed text-size-14"
                  maxlength="300"
                  type="text"
                  :value="getQuestionAnswer(6, 0)"
                  @input="changeQuestions($event, 6, 1)"
                  :placeholder="
                    $t(
                      'lang.onBoarding.step1_7_item_example1',
                      this.$store.state.onboarding.lang
                    )
                  "
                />
              </div>
              <p v-show="showInputMessage(6, 0)" class="text-left ml-4">
                {{ characterResponseCounter(6, 1, 300) }}
              </p>
            </div>
          </div>
          <div class="col-12 mt-2">
            <div class="row">
              <div class="col-12 d-flex justify-content-start px-0">
                <span class="d-flex align-items-end">2.</span>
                <input
                  @focus="showMessage(6, 'enable', 1)"
                  @blur="showMessage(6, 'disable', 1)"
                  class="w-50 text-primary flex-fill mt-2 mx-2 mb-1 lead pl-2 border-style-dashed text-size-14"
                  maxlength="300"
                  type="text"
                  :value="getQuestionAnswer(6, 1)"
                  @input="changeQuestions($event, 6, 2)"
                  :disabled="disabledEdit()"
                  :placeholder="
                    $t(
                      'lang.onBoarding.step1_7_item_example2',
                      this.$store.state.onboarding.lang
                    )
                  "
                />
              </div>
              <p v-show="showInputMessage(6, 1)" class="text-left ml-4">
                {{ characterResponseCounter(6, 2, 300) }}
              </p>
            </div>
          </div>
          <div class="col-12 mt-2">
            <div class="row">
              <div class="col-12 d-flex justify-content-start px-0">
                <span class="d-flex align-items-end">3.</span>
                <input
                  :disabled="disabledEdit()"
                  @focus="showMessage(6, 'enable', 2)"
                  @blur="showMessage(6, 'disable', 2)"
                  class="w-50 text-primary flex-fill mt-2 mx-2 mb-1 lead pl-2 border-style-dashed text-size-14"
                  maxlength="300"
                  type="text"
                  :value="getQuestionAnswer(6, 2)"
                  @input="changeQuestions($event, 6, 3)"
                  :placeholder="
                    $t(
                      'lang.onBoarding.step1_7_item_example3',
                      this.$store.state.onboarding.lang
                    )
                  "
                />
              </div>
              <p v-show="showInputMessage(6, 2)" class="text-left ml-4">
                {{ characterResponseCounter(6, 3, 300) }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Tab - Targeting -->
      <div class="m-0 p-0" v-if="onBoarding.step3.tabId == 3">
        <TargetContactImport
          v-if="isActivationOrder"
          ref="activationContactImport"
          :targetId="onBoarding.orderId"
          :targetStatusId="target_status_id"
          :disabled="disabledEdit()"
          @contacts-changed="onActivationContactsChanged"
        />
        <div v-else class="col-12 p-0 mt-2">
          <div class="p-2 m-0 text-left">
            <div class="row">
              <div class="col-md-5 p-0 border-right">
                <div class="">
                  <div class="card-body pt-0 px-3">
                    <LoadingSpinner v-if="step2SummaryLoading" />
                    <Step2Summary
                      v-else-if="step2SummaryReady"
                      :key="'step2-tab-' + onBoarding.orderId + '-' + step2sum"
                      :poupView="true"
                      @change="refreshTarget($event)"
                      :selectDisable="disabledEdit()"
                      @save="savenow(false, false)"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-7">
                <TargetsModal
                  :key="targetkey"
                  :contactkey="targetkey + 1"
                  :contacts="apolloResult"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Tab - Sequence -->
      <div v-if="onBoarding.step3.tabId == 4">
        <div class="row mt-0 mx-0">
          <div class="col-12 pr-2">
            <div class="card">
              <div class="col-12 p-1 m-0">
                <div class="row">
                  <div
                    :class="
                      [1, 3, 4].includes(Number(onBoarding.target_status_id)) ? 'col-8' : 'col-12'
                    "
                  >
                    <button
                      class="btn btn-sm btn-primary ml-3 mt-3 mb-3"
                      @click="generateNew()"
                      v-if="
                        verificationOrder.status == 1 &&
                          !emptySequence &&
                          onBoarding.modelCampaingStep.tabSelected.id == 3
                      "
                    >
                      {{ $t("lang.orders.generate_example") }}
                    </button>
                    <div class="row">
                      <div class="col-12">
                        <button
                          class="btn btn-primary mt-3"
                          @click="showModalTips()"
                          v-if="false"
                        >
                          {{ $t("lang.label.about_copywriting") }}
                        </button>
                        <div class="float-left">
                          <vue-form-generator
                            ref="annualSubscription"
                            :schema="schemaPreviewTemplate"
                            :model="onBoarding"
                            :options="formOptions"
                          >
                          </vue-form-generator>
                        </div>
                        <div class="float-right mt-3">
                          <button
                            v-if="
                              !loading && hasPermissions('superAdminTargets')
                            "
                            class="float-right btn rounded-circle ml-1 cursor-pointer btn-sm btn-primary"
                            @click="showModal('mails')"
                            type="button"
                          >
                            <i class="icon-expand"></i>
                          </button>
                          <button
                            v-if="
                              !loading && hasPermissions('superAdminTargets')
                            "
                            class="mr-2 float-right btn rounded-circle cursor-pointer btn-sm btn-secondary"
                            @click="editStep(1)"
                            type="button"
                          >
                            <i class="icon-pencil"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="
                        !loading &&
                          (hasPermissions('adminAgency') ||
                            (hasPermissions('billing') &&
                              (verificationOrder.status == 1||target_status_id == 3))) &&
                          previewTemplate()
                      "
                    >
                      <TargetStepCampaingPreview
                        v-if="onBoarding.modelCampaingStep.tabSelected.id == 1"
                        :model="onBoarding.modelCampaingStep"
                        :availableTokens="availableTokens"
                        :preview="true"
                        :availableTokensSelect="availableTokens"
                      />
                      <!-- v-if="!previewEmail" -->

                      <PreviewSequencesEmail
                        v-else-if="
                          !emptySequence &&
                            onBoarding.modelCampaingStep.tabSelected.id == 3 &&
                            !regenerateEmail
                        "
                        :target_id="targetId"
                        class="mt-3"
                        @emptySequence="checkSequence()"
                      />
                      <!-- </div> -->

                      <!-- </div> -->

                      <PreviewEmail
                        class="p-4"
                        :tag_id="Number(tag_id)"
                        :templateId="1"
                        :resumed="true"
                        v-else-if="
                          onBoarding.modelCampaingStep.tabSelected.id == 2
                        "
                        :subject="'Re'"
                      />

                      <LoadingSpinner v-if="loading" />
                    </div>
                    <div v-else class="content-center">
                      <div class="text-center">
                        <div>
                          <img
                            src="@/assets/images/icon_file.png"
                            alt="file"
                            srcset=""
                          />
                        </div>
                        <span class="mt-5">
                          <>{{ $t("lang.onBoarding.sequence_info") }}</>
                        </span>
                      </div>
                      <div class="text-center" v-if="false">
                        <button
                          @click="goToSubStep(1, 1)"
                          class="btn btn-primary"
                        >
                          {{ $t("lang.onBoarding.gotostep", { step: "1/3" }) }}
                        </button>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-4 p-3"
                    v-if="[1, 3, 4].includes(Number(onBoarding.target_status_id))"
                  >
                    <TargetNote
                      :targetId="targetId"
                      :currentUserId="currentUser.id"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Tab - Cold Call Script -->
      <ColdCallScript
        v-if="onBoarding.step3.tabId == 5"
        :targetId="targetId"
      />

      <!-- Tab - Statistics -->
      <div v-if="onBoarding.step3.tabId == 6">
        <GraphOfStats :targetId="targetId" />
      </div>

      <!-- Tab - Envois -->
      <div v-if="onBoarding.step3.tabId === 7">
        <!-- <CampaignsEmails :targetId="targetId" /> -->
        <CampaignsEmailsByStep :targetId="targetId" />
      </div>

      <!-- Tab - Profitability -->
      <div v-if="onBoarding.step3.tabId === 8">
        <Profitability :targetId="targetId" />
      </div>

      <!-- Tab - Billing -->
      <div v-if="onBoarding.step3.tabId === 9">
        <BillingToOrder :targetId="targetId" :user_id="onBoarding.user_id" />
      </div>

      <!-- Tab - Prospectors -->
      <div v-if="onBoarding.step3.tabId === 10">
        <!-- <ListSDRTeam :client_id="onBoarding.client_id" :targetId="targetId" /> -->
        <Prospectors :targetId="targetId" />
      </div>

      <!-- Tab - Campaign Healts -->
      <TargetCampaigns
        v-if="onBoarding.step3.tabId === 11"
        :target_id="targetId"
      ></TargetCampaigns>

      <!-- Tab - Inbox -->
      <div v-if="onBoarding.step3.tabId === 12">
        <AllEmails :isDashboard="true" :targetId="targetId" />
      </div>
      <div v-if="onBoarding.step3.tabId === 13">
        <Diagnostic :targetId="targetId" />
      </div>

      <!-- Tab - Timming -->
      <div v-if="onBoarding.step3.tabId === 14">
        <BookerOverview type="timing" :targetId="targetId"/>
      </div>

      <!-- Tab - Booker tasks -->
      <div v-if="onBoarding.step3.tabId === 15">
        <BdrTasks :targetId="targetId"/>
      </div>

    </div>

    <div class="container-fluid mt-4">
      <div class="row" v-if="typeForm == 'onboarding'">
        <div class="col-12 d-flex justify-content-end">
          <div class="btn-group dropleft float-right">
            <button
              class="btn cursor-pointer font-weight-bolder btn-sm btn-primary m-1 mt-2 px-4"
              :disabled="saving"
              type="button"
              @click="savenow(false, false)"
              v-if="!disabledEdit() && typeForm == 'onboarding'"
            >
              {{ $t("lang.button.save") }}
              <span
                v-if="saving"
                class="loadingres mr-1 ml-1 spinner-border loading-spinner text-white"
              ></span>
            </button>

            <button
              v-if="
                canSubmitForValidation &&
                  onBoarding.orderId &&
                  onBoarding.target_status_id == 3
              "
              class="btn cursor-pointer font-weight-bolder btn-sm btn-primary m-1 mt-2 px-4"
              :disabled="saving"
              type="button"
              @click="validate()"
            >
              {{ $t("lang.onBoarding.start_preparing_my_campaigns") }}
              <span class="img-btn">
                <img src="@/assets/images/icono-wp.png" alt />
              </span>
              <span
                v-if="saving"
                class="loadingres mr-1 ml-1 spinner-border loading-spinner text-primary"
              ></span>
            </button>
          </div>
        </div>
      </div>

      <div class="row" v-if="simplify || addOrder">
        <div
          class="col-12 d-flex justify-content-end mb-4"
          v-if="
            onBoarding.step3.tabId != 5 &&
              onBoarding.step3.tabId != 11 &&
              onBoarding.step3.tabId != 7 &&
              onBoarding.step3.tabId != 8 &&
              onBoarding.step3.tabId != 10 &&
              onBoarding.step3.tabId != 12 &&
              onBoarding.step3.tabId != 13
          "
        >
          <div class="btn-group dropleft float-right">
            <!-- buttons  -->
             <!-- soumettre à validation btn inferior -->
            <button
              v-if="
                canSubmitForValidation &&
                  onBoarding.orderId &&
                  onBoarding.target_status_id != 3 &&
                  ![1, 4].includes(Number(onBoarding.target_status_id))
              "
              class="btn cursor-pointer font-weight-bolder btn-sm btn-primary m-1 mt-2 px-4"
              :disabled="saving"
              type="button"
              @click="validate()"
            >
              {{ $t("lang.onBoarding.start_preparing_my_campaigns") }}
              <span class="img-btn">
                <img src="@/assets/images/icono-wp.png" alt />
              </span>
              <span
                v-if="saving"
                class="loadingres mr-1 ml-1 spinner-border loading-spinner text-primary"
              ></span>
            </button>

            <button
              class="btn cursor-pointer font-weight-bolder btn-sm btn-outline-dark m-1 mt-2 px-4"
              v-if="!simplify && addOrder && false"
              type="button"
              @click="goToSubStep(2, 1)"
            >
              {{ $t("lang.button.back") }}
            </button>

            <button
              class="btn cursor-pointer font-weight-bolder btn-sm btn-primary m-1 mt-2 px-4"
              type="button"
              :disabled="saving"
              @click="savenow(true, true)"
              v-if="canSubmitForValidation && target_status_id == 2"
            >
              {{ $t("lang.button.setalive") }}
            </button>

            <button
              v-if="parseInt(target_status_id) == 5"
              class="btn cursor-pointer font-weight-bolder btn-sm btn-secondary m-1 mt-2 px-4"
              type="button"
              @click="changeStatus(3)"
            >
              {{ $t("lang.button.restore") }}
            </button>

            <button
              v-if="
                  parseInt(target_status_id) == 2
              "
              class="btn cursor-pointer font-weight-bolder btn-sm btn-warning m-1 mt-2 px-4"
              type="button"
              @click="changeStatus(5)"
            >
              {{ $t("lang.campaigns_dashboard.archivecampaign") }}
            </button>

            <Tooltip :text="$t('lang.general.reachouttoourteam')" :width="''">
              <button
                v-if="
                  parseInt(target_status_id) == 1 &&
                    !hasPermissions('adminAgency') &&
                    !addOrder
                "
                class="btn cursor-pointer font-weight-bolder btn-sm btn-danger m-1 mt-2 px-4"
                type="button"
                disabled
              >
                {{ $t("lang.button.stop") }}
              </button>
            </Tooltip>
          </div>
        </div>
      </div>
    </div>

    <section v-if="simplify == 'notDisplay'">
      <LoadingSpinner v-if="loading" />
      <div v-if="!loading" class="col-md-12">
        <h2 v-if="!simplify && false">Step 3 / 3</h2>
        <h3 class="card-title text-primary mb-4" v-if="!simplify">
          <span v-if="addOrder">
            {{ $t("lang.onBoarding.finalizing_order") }}
          </span>
          <span v-else>
            {{ $t("lang.onBoarding.first_order_meeting") }}
          </span>
        </h3>
        <h4 class="mb-4" v-if="!simplify && false">
          {{ $t("lang.label.summary") }}
        </h4>

        <!-- Switch / Close order -->
        <!-- <div
          class="col-12 mt-4"
          v-if="
            hasPermissions('superAdminTargets') &&
            onBoarding.validationTarget.status == 1
          "
        >
          <div class="float-right">
            <vue-form-generator
              :schema="schemaCloseOrder"
              :model="onBoarding"
              @model-updated="saveOrderClosed()"
            >
            </vue-form-generator>
          </div>
        </div> -->

        <div class="row" v-if="simplify && onBoarding.orderId">
          <div class="col-6">
            <h4 class="my-3 float-left">{{ $t("lang.label.edit") }}</h4>
          </div>
        </div>
        <div class="row my-2" v-if="simplify">
          <div class="col-12">
            {{ $t("lang.column.status") }}:
            <span
              v-if="target_status_id == 1"
              class="badge badge-primary text-white px-3 py-2"
            >
              {{ $t("lang.targets.active") }}</span
            >
            <span
              v-if="target_status_id == 2"
              class="badge badge-danger text-white px-3 py-2"
            >
              {{ $t("lang.targets.stopped") }}</span
            >
            <span
              v-if="target_status_id == 3"
              class="badge badge-secondary text-white px-3 py-2"
            >
              {{ $t("lang.targets.pending") }}</span
            >
            <span
              v-if="target_status_id == 4"
              class="badge badge-success text-white px-3 py-2"
            >
              {{ $t("lang.targets.running") }}</span
            >
            <span
              v-if="target_status_id == 5"
              class="badge badge-warning text-white px-3 py-2"
            >
              {{ $t("lang.targets.archived") }}</span
            >
          </div>
        </div>
        <!-- Order name -->
        <div class="row my-2">
          <div class="col-12">
            {{ $t("lang.orders.name") }}:<i class="text-danger">*</i>

            <strong
              v-if="!isOpen('orderName')"
              class="text-primary border-0 pl-0 ml-2"
            >
              {{ onBoarding.orderName }}
            </strong>
            <span v-else-if="isOpen('orderName')">
              <input
                min="1"
                max="100"
                class="text-primary mx-2 text-center"
                type="text"
                :value="onBoarding.orderName"
                @input="changeOrderName"
              />
            </span>
            <button
              class="ml-1 btn rounded-circle cursor-pointer btn-sm btn-secondary d-inline"
              type="button"
              v-if="!isOpen('orderName') && !disabledEdit()"
              @click="openEdit('orderName')"
            >
              <i class="icon-pencil"></i>
            </button>
            <button
              v-if="isOpen('orderName')"
              @click="closeEdit('orderName')"
              class="ml-1 btn cursor-pointer btn-sm btn-success d-inline"
              type="button"
            >
              <i class="icon-check1"></i> {{ $t("lang.button.save") }}
            </button>
          </div>
        </div>

        <!-- Promotion -->
        <div class="row my-2">
          <div class="col-12">
            <span class="d-inline">
              {{ $t("lang.onBoarding.step1_2_question") }}:<i
                class="text-danger"
                >*</i
              >
            </span>
            <span>
              <div
                class="wrapper"
                v-if="onBoarding.step3.tag_id || isOpen('whatToPromote')"
              >
                <select
                  v-model="onBoarding.step3.tag_id"
                  :disabled="!isOpen('whatToPromote')"
                  :class="
                    !isOpen('whatToPromote')
                      ? 'border-0 text-primary bg-white'
                      : ''
                  "
                  class="d-inline form-control"
                  @change="changeTagId"
                  v-if="tag_2 !== undefined"
                >
                  <option
                    v-for="(tag, i) in tag_2.data"
                    :key="`Tag${i}`"
                    :value="tag.id"
                    class="optionSelect"
                  >
                    {{ tag.name }}
                  </option>
                </select>
              </div>
            </span>
            <button
              class="ml-1 btn rounded-circle cursor-pointer btn-sm btn-secondary border-0 d-inline"
              :class="onBoarding.step3.tag_id ? '' : 'bg-danger'"
              type="button"
              v-if="!isOpen('whatToPromote') && !disabledEdit()"
              @click="openEdit('whatToPromote')"
            >
              <i class="icon-pencil"></i>
            </button>
            <button
              v-if="isOpen('whatToPromote')"
              @click="closeEdit('whatToPromote')"
              class="ml-1 btn cursor-pointer btn-sm btn-success d-inline"
              type="button"
            >
              <i class="icon-check1"></i> {{ $t("lang.button.save") }}
            </button>
          </div>
        </div>

        <!-- Product name -->
        <div class="row my-2">
          <div class="col-12">
            {{ $t("lang.token.product_name") }}:<i class="text-danger">*</i>
            <strong
              v-if="!isOpen('productName')"
              class="text-primary border-0 pl-0 ml-2"
            >
              {{ onBoarding.productName }}
            </strong>
            <span v-else-if="isOpen('productName')">
              <input
                min="1"
                max="100"
                class="form-control"
                type="text"
                :value="onBoarding.productName"
                @input="changeProductName"
              />
            </span>
            <button
              class="ml-1 btn rounded-circle cursor-pointer border-0 btn-sm btn-secondary d-inline"
              :class="onBoarding.productName ? '' : 'bg-danger'"
              type="button"
              v-if="!isOpen('productName') && !disabledEdit()"
              @click="openEdit('productName')"
            >
              <i class="icon-pencil"></i>
            </button>
            <button
              v-if="isOpen('productName')"
              @click="closeEdit('productName')"
              class="ml-1 btn cursor-pointer btn-sm btn-success d-inline"
              :disabled="onBoarding.productName == ''"
              type="button"
            >
              <i class="icon-check1"></i> {{ $t("lang.button.save") }}
            </button>
          </div>
        </div>

        <!-- Name Company -->
        <div class="row my-2">
          <div class="col-12">
            {{ $t("lang.label.companyname") }}:
            <span class="text-primary border-0 pl-0 ml-2"
              >{{ onBoarding.companyName }}
            </span>
          </div>
        </div>

        <!-- Url Web Page -->
        <div class="row my-2">
          <div class="col-12 py-1">
            {{ $t("lang.label.landingPage") }}:<i class="text-danger">*</i>
            <a
              class="text-primary pl-0 ml-2"
              target="_blank"
              type="button"
              v-if="!isOpen('website')"
              :href="onBoarding.website"
            >
              {{ onBoarding.website }}
            </a>
            <span class="my-0 py-0" v-if="isOpen('website')">
              <vue-form-generator
                class="d-inline-block mx-2"
                ref="websiteForm"
                :schema="schemaWebsite"
                :model="modelform"
                :options="formOptions"
              ></vue-form-generator>
            </span>
            <button
              class="ml-1 btn rounded-circle cursor-pointer btn-sm btn-secondary d-inline border-0"
              :class="onBoarding.website ? '' : 'bg-danger'"
              type="button"
              v-if="!isOpen('website') && !disabledEdit()"
              @click="openEdit('website')"
            >
              <i class="icon-pencil"></i>
            </button>
            <button
              v-if="isOpen('website')"
              :disabled="modelform.website == '' || formValidation.urlIsValid"
              @click="changeWebsite()"
              class="ml-1 btn cursor-pointer btn-sm btn-success d-inline"
              type="button"
            >
              <i class="icon-check1"></i> {{ $t("lang.button.save") }}
            </button>
          </div>
          <div class="col-12 my-0 py-0">
            <span v-if="formValidation.urlIsValid" class="text-danger">{{
              $t("lang.orders.url_invalid")
            }}</span>
          </div>
        </div>

        <!-- Description Sell -->
        <div class="row my-2">
          <div class="col-12">
            {{ $t("lang.orders.description_sell") }}:<i class="text-danger"
              >*</i
            >

            <strong
              v-if="!isOpen('orderDescriptionSell')"
              class="text-primary border-0 pl-0 ml-2"
            >
              <span v-if="onBoarding.descriptionSell"
                >{{ onBoarding.descriptionSell.substr(0, 20) }} ...</span
              >
            </strong>
            <p v-else-if="isOpen('orderDescriptionSell')">
              <textarea
                class="form-control"
                name=""
                rows="3"
                :value="onBoarding.descriptionSell"
                @input="changeDescriptionSell"
              >
              </textarea>
            </p>
            <button
              class="ml-1 btn rounded-circle cursor-pointer btn-sm btn-secondary d-inline"
              :class="onBoarding.descriptionSell ? '' : 'bg-danger'"
              type="button"
              v-if="!isOpen('orderDescriptionSell') && !disabledEdit()"
              @click="openEdit('orderDescriptionSell')"
            >
              <i class="icon-pencil"></i>
            </button>
            <div v-if="isOpen('orderDescriptionSell')" class="ml-0 mt-0">
              <div class="mt-2">
                <button
                  :disabled="
                    !onBoarding.descriptionSell || !correctNumberCharacters
                  "
                  @click="closeEdit('orderDescriptionSell')"
                  class="ml-1 mt-0 btn cursor-pointer btn-sm btn-success d-inline"
                  type="button"
                >
                  <i class="icon-check1"></i> {{ $t("lang.button.save") }}
                </button>
                <small
                  class="ml-3 pt-2 font-weight-bold"
                  :class="{
                    'text-success': correctNumberCharacters,
                    'text-danger': !correctNumberCharacters
                  }"
                  >{{ textQtyCharacters }}</small
                >
              </div>
            </div>
          </div>
        </div>

        <!-- OFFER CLIENT POTENTIAL -->
        <div class="row my-2">
          <div class="col-12">
            <span class="d-inline">
              {{ $t("lang.onBoarding.offer_client_potential") }}:<i
                class="text-danger"
                >*</i
              >
            </span>
            <span>
              <div
                class="wrapper"
                v-if="onBoarding.offer_prospect || isOpen('potentialClient')"
              >
                <select
                  v-model="onBoarding.offer_prospect"
                  :disabled="!isOpen('potentialClient')"
                  :class="
                    !isOpen('potentialClient')
                      ? 'border-0 text-primary bg-white'
                      : ''
                  "
                  class="d-inline form-control"
                  @change="changeOfferProspect"
                >
                  <option
                    v-for="(offer, i) in select_offer_prospect"
                    :key="offer.id"
                    :value="offer.id"
                    class="optionSelect"
                  >
                    {{ offer.label }}
                  </option>
                </select>
              </div>
            </span>
            <button
              class="ml-1 btn rounded-circle cursor-pointer btn-sm btn-secondary border-0 d-inline"
              :class="onBoarding.step3.tag_id ? '' : 'bg-danger'"
              type="button"
              v-if="!isOpen('potentialClient') && !disabledEdit()"
              @click="openEdit('potentialClient')"
            >
              <i class="icon-pencil"></i>
            </button>
            <button
              v-if="isOpen('potentialClient')"
              @click="closeEdit('potentialClient')"
              class="ml-1 btn cursor-pointer btn-sm btn-success d-inline"
              type="button"
            >
              <i class="icon-check1"></i> {{ $t("lang.button.save") }}
            </button>
          </div>
        </div>

        <!-- Fill in the main benefits of your offer -->
        <div class="row my-2">
          <div class="col-12">
            {{ $t("lang.onBoarding.benefits_offer") }}:<i class="text-danger"
              >*</i
            >

            <strong
              v-if="!isOpen('benefecitYourOffer')"
              class="text-primary border-0 pl-0 ml-2"
            >
              <span v-if="onBoarding.offer_benefits"
                >{{ onBoarding.offer_benefits.substr(0, 20) }} ...</span
              >
            </strong>
            <p v-else-if="isOpen('benefecitYourOffer')">
              <textarea
                class="form-control"
                name=""
                rows="3"
                :value="onBoarding.offer_benefits"
                @input="changeBenefitsOffer"
              >
              </textarea>
            </p>
            <button
              class="ml-1 btn rounded-circle cursor-pointer btn-sm btn-secondary d-inline"
              :class="onBoarding.offer_benefits ? '' : 'bg-danger'"
              type="button"
              v-if="!isOpen('benefecitYourOffer') && !disabledEdit()"
              @click="openEdit('benefecitYourOffer')"
            >
              <i class="icon-pencil"></i>
            </button>
            <div v-if="isOpen('benefecitYourOffer')" class="ml-0 mt-0">
              <div class="mt-2">
                <button
                  :disabled="
                    !onBoarding.offer_benefits ||
                      !correctNumberCharactersGlobal(onBoarding.offer_benefits)
                  "
                  @click="closeEdit('benefecitYourOffer')"
                  class="ml-1 mt-0 btn cursor-pointer btn-sm btn-success d-inline"
                  type="button"
                >
                  <i class="icon-check1"></i> {{ $t("lang.button.save") }}
                </button>
                <small
                  class="ml-3 pt-2 font-weight-bold"
                  :class="{
                    'text-success': correctNumberCharactersGlobal(
                      onBoarding.offer_benefits
                    ),
                    'text-danger': !correctNumberCharactersGlobal(
                      onBoarding.offer_benefits
                    )
                  }"
                  >{{
                    textQtyCharactersGlobal(onBoarding.offer_benefits)
                  }}</small
                >
              </div>
            </div>
          </div>
        </div>

        <!-- Fill in some evidence that makes your offer more attractive than others -->
        <div class="row my-2">
          <div class="col-12">
            {{ $t("lang.onBoarding.offer_attractive") }}:<i class="text-danger"
              >*</i
            >

            <strong
              v-if="!isOpen('offerMoreAttractive')"
              class="text-primary border-0 pl-0 ml-2"
            >
              <span v-if="onBoarding.offer_attractive"
                >{{ onBoarding.offer_attractive.substr(0, 20) }} ...</span
              >
            </strong>
            <p v-else-if="isOpen('offerMoreAttractive')">
              <textarea
                class="form-control"
                name=""
                rows="3"
                :value="onBoarding.offer_attractive"
                @input="changeOfferAttractive"
              >
              </textarea>
            </p>
            <button
              class="ml-1 btn rounded-circle cursor-pointer btn-sm btn-secondary d-inline"
              :class="onBoarding.offer_attractive ? '' : 'bg-danger'"
              type="button"
              v-if="!isOpen('offerMoreAttractive') && !disabledEdit()"
              @click="openEdit('offerMoreAttractive')"
            >
              <i class="icon-pencil"></i>
            </button>
            <div v-if="isOpen('offerMoreAttractive')" class="ml-0 mt-0">
              <div class="mt-2">
                <button
                  :disabled="
                    !onBoarding.offer_attractive ||
                      !correctNumberCharactersGlobal(
                        onBoarding.offer_attractive
                      )
                  "
                  @click="closeEdit('offerMoreAttractive')"
                  class="ml-1 mt-0 btn cursor-pointer btn-sm btn-success d-inline"
                  type="button"
                >
                  <i class="icon-check1"></i> {{ $t("lang.button.save") }}
                </button>
                <small
                  class="ml-3 pt-2 font-weight-bold"
                  :class="{
                    'text-success': correctNumberCharactersGlobal(
                      onBoarding.offer_attractive
                    ),
                    'text-danger': !correctNumberCharactersGlobal(
                      onBoarding.offer_attractive
                    )
                  }"
                  >{{
                    textQtyCharactersGlobal(onBoarding.offer_attractive)
                  }}</small
                >
              </div>
            </div>
          </div>
        </div>

        <!-- Appointment -->
        <div class="row my-1">
          <div class="col-12">
            <span v-if="!isOpen('appointment')">
              {{ $t("lang.onBoarding.expected_value_appointments") }}:
              <b class="text-primary">{{
                onBoarding.step3.appointmentVolume
              }}</b>
              /
              {{ $t("lang.label.month") }}
            </span>
            <span v-else-if="isOpen('appointment')">
              <span class="bg-white border-0 pl-0"
                >{{ $t("lang.onBoarding.expected_value_appointments") }}
              </span>
              <span class="mx-2">
                <div class="wrapper">
                  <input
                    min="10"
                    max="100"
                    class="form-control"
                    type="number"
                    v-model="onBoarding.step3.appointmentVolume"
                    @input="changeAppointmentVolume"
                  />
                </div>
              </span>

              <span class="bg-white border-0 pl-0 pt-0">
                / {{ $t("lang.label.month") }}
              </span>
            </span>

            <button
              class="ml-1 btn rounded-circle cursor-pointer btn-sm btn-secondary d-inline"
              type="button"
              v-if="!isOpen('appointment') && !disabledEdit()"
              @click="openEdit('appointment')"
            >
              <i class="icon-pencil"></i>
            </button>
            <button
              v-if="isOpen('appointment')"
              @click="closeEdit('appointment')"
              :disabled="
                onBoarding.step3.appointmentVolume == '' ||
                  formValidation.appointment
              "
              class="ml-1 btn cursor-pointer btn-sm btn-success d-inline"
              type="button"
            >
              <i class="icon-check1"></i> {{ $t("lang.button.save") }}
            </button>
          </div>
          <div class="col-12 my-0 py-0">
            <span v-if="formValidation.appointment" class="text-danger">{{
              $t("lang.orders.appointment_invalid")
            }}</span>
          </div>
        </div>

        <!-- Launch Date -->
        <div class="row my-1">
          <div class="col-12">
            <span v-if="!isOpen('launchDate')">
              {{ $t("lang.onBoarding.launch_date_campaign") }}:<i
                class="text-danger"
                >*</i
              >
              <b
                class="text-primary ml-2"
                style="
                  width: 98px !important;
                  overflow: hidden;
                  display: inherit;
                  height: 18px;
                "
                >{{ onBoarding.step3.launchDate }}
              </b>
            </span>
            <span v-else-if="isOpen('launchDate')">
              <span class="bg-white border-0 pl-0"
                >{{ $t("lang.onBoarding.launch_date_campaign") }}:
              </span>
              <vue-form-generator
                class="d-inline-block mx-4"
                ref="launchDateForm"
                :schema="schemaStatus"
                :model="modelform"
                :options="formOptions"
              ></vue-form-generator>
            </span>
            <!-- not the pencil button in /orders/id -->
            <button
              class="ml-2 btn rounded-circle cursor-pointer btn-sm border-0 btn-secondary"
              :class="onBoarding.step3.launchDate ? '' : 'bg-danger'"
              type="button"
              v-if="!isOpen('launchDate') && !disabledEdit()"
              @click="openEdit('launchDate')"
            >
              <i class="icon-pencil"></i>
            </button>
            <button
              v-if="isOpen('launchDate')"
              @click="changeLaunchDate()"
              :disabled="
                onBoarding.step3.launchDate == '' ||
                  ($refs.launchDateForm !== undefined &&
                    $refs.launchDateForm.errors.length > 0)
              "
              class="ml-1 btn cursor-pointer btn-sm btn-success"
              type="button"
            >
              <i class="icon-check1"></i> {{ $t("lang.button.save") }}
            </button>
          </div>
        </div>

        <!-- Language -->
        <div class="row my-2">
          <div class="col-12">
            {{ $t("lang.label.language") }}:<i class="text-danger">*</i>
            <span
              v-if="!isOpen('language') && onBoarding.lang !== ''"
              class="text-primary bg-white border-0 pl-0 ml-2"
            >
              {{ this.$t("lang.onBoarding.lang." + onBoarding.lang) }}
            </span>
            <span v-else-if="isOpen('language')">
              <select v-model="onBoarding.lang" class="langSelect form-control">
                <option
                  v-for="(lang, i) in langs"
                  :key="`Lang${i}`"
                  :value="lang.type"
                  class="optionSelect"
                >
                  {{ lang.label }}
                </option>
              </select>
            </span>
            <button
              class="ml-1 btn rounded-circle cursor-pointer btn-sm btn-secondary d-inline border-0"
              :class="onBoarding.lang ? '' : 'bg-danger'"
              type="button"
              v-if="
                !isOpen('language') &&
                  !disabledEdit() &&
                  (this.target_status_id == 3 || this.target_status_id == null)
              "
              @click="openEdit('language')"
            >
              <i class="icon-pencil"></i>
            </button>
            <button
              v-if="isOpen('language')"
              @click="changeLanguage(true)"
              class="ml-1 btn cursor-pointer btn-sm btn-success d-inline"
              type="button"
            >
              <i class="icon-check1"></i> {{ $t("lang.button.save") }}
            </button>
          </div>
        </div>

        <!-- Price -->
        <div class="row my-2">
          <div class="col-12">
            <span v-if="!isOpen('editingAppointPrice')">
              {{ $t("lang.onBoarding.my_price_appointment") }}
              <b class="text-primary"
                >{{ onBoarding.step3.appointmentPrice }} €
                {{ $t("lang.label.net") }} / {{ $t("lang.label.meeting") }}</b
              >
              <b class="text-primary ml-1" v-if="false">
                ({{
                  $t("lang.onBoarding.prospects", {
                    prospects: new Intl.NumberFormat("es-ES").format(
                      onBoarding.apollo.total_result
                    )
                  })
                }})
              </b>
            </span>
            <span v-else-if="isOpen('editingAppointPrice')">
              <span class="bg-white border-0 pl-0"
                >{{ $t("lang.onBoarding.my_price_appointment") }}
              </span>

              <span class="mx-2">
                <div class="wrapper">
                  <input
                    min="1"
                    max="500"
                    class="form-control"
                    type="number"
                    :value="onBoarding.step3.appointmentPrice"
                    @input="changeAppointmentPrice"
                  />
                </div>
              </span>
            </span>

            <button
              class="ml-1 btn rounded-circle cursor-pointer btn-sm btn-secondary d-inline"
              type="button"
              v-if="
                !isOpen('editingAppointPrice') &&
                  hasPermissions('superAdminTargets') &&
                  simplify
              "
              @click="openEdit('editingAppointPrice')"
            >
              <i class="icon-pencil"></i>
            </button>
            <button
              v-if="isOpen('editingAppointPrice')"
              @click="closeEdit('editingAppointPrice')"
              class="ml-1 btn cursor-pointer btn-sm btn-success d-inline"
              type="button"
            >
              <i class="icon-check1"></i> {{ $t("lang.button.save") }}
            </button>
            <div
              class="row my-2"
              v-if="
                hasPermissions('superAdminTargets') &&
                  (onBoarding.target_status_id == 1 ||
                    onBoarding.target_status_id == 4)
              "
            >
              <div class="col-12">
                Verified:
                <span
                  v-if="!isOpen('verified')"
                  class="text-primary bg-white border-0 pl-0"
                >
                  {{ verificationOrder.label }}
                </span>
                <span v-else-if="isOpen('verified')">
                  <StatusComment
                    :status="verificationOrder.status"
                    :comments="verificationOrder.comment"
                    @onChange="changeVerificateOrder(...arguments)"
                  />
                </span>
                <button
                  class="ml-1 btn rounded-circle cursor-pointer btn-sm btn-secondary d-inline"
                  type="button"
                  v-if="!isOpen('verified')"
                  @click="openEdit('verified')"
                >
                  <i class="icon-pencil"></i>
                </button>
                <button
                  v-if="isOpen('verified')"
                  @click="verificateOrder()"
                  class="ml-1 btn rounded-circle cursor-pointer btn-sm btn-success d-inline"
                  type="button"
                >
                  <i class="icon-check1"></i>
                </button>
              </div>
              <!-- aqui va estatus -->
            </div>
          </div>
        </div>

        <!-- MODAL Targets -->
        <Modal :name="'targets'" @closeModal="closeModal">
          <div class="p-4 text-left">
            <h3 class="card-title text-primary mb-2">
              {{ $t("lang.onBoarding.target_modal_title") }}
            </h3>
            <p class="text-secondary mb-3">
              {{ $t("lang.onBoarding.target_modal_description") }}
            </p>
            <div class="row">
              <div class="col-md-5">
                <div class="card">
                  <div class="card-body">
                    <LoadingSpinner v-if="step2SummaryLoading" />
                    <Step2Summary
                      v-else-if="step2SummaryReady"
                      :key="'step2-modal-' + onBoarding.orderId + '-' + step2sum"
                      :poupView="true"
                      @change="refreshTarget($event)"
                      :selectDisable="false"
                      @save="savenow(false, false)"
                    />
                    <button
                      class="float-right btn cursor-pointer font-weight-bolder btn-sm btn-primary m-1 mt-4 px-4"
                      type="button"
                      @click="
                        savenow(false, false);
                        closeModal('targets');
                      "
                      v-if="!disabledEdit()"
                    >
                      {{ $t("lang.button.save") }}
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-md-7">
                <TargetsModal
                  v-if="!onBoarding.loading"
                  :key="targetkey"
                  :contactkey="targetkey + 1"
                  :contacts="apolloResult"
                />
              </div>
            </div>
          </div>
        </Modal>
        <div class="card my-3" v-if="!simplify && !addOrder">
          <div class="card-title mx-3 mt-3">
            <h5>
              {{ $t("lang.onBoarding.people_in_team_receiving_appointments") }}
            </h5>
          </div>

          <TeamMembers @save="savenow(false, false)" />
        </div>
        <div class="card my-3 p-3" v-if="simplify || addOrder">
          {{ $t("lang.onBoarding.who_is_thesales") }}
          <LoadingSpinner v-if="loadingSales" />
          <IndustrySearch
            v-if="!loadingSales"
            :option_list="salesRep"
            :default_values="modelform.sales"
            :isDisabled="disabledEditSales()"
            @closed="updateSales(modelform.sales)"
          >
          </IndustrySearch>
          <small class="text-danger my-3" v-if="salesRep.length == 0">
            {{ $t("lang.orders.unavailablesales") }}</small
          >
        </div>
        <div class="row mt-4">
          <div class="col-md-6 pr-2">
            <div class="card">
              <div class="row">
                <div class="col-12">
                  <div class="float-right">
                    <vue-form-generator
                      ref="annualSubscription"
                      :schema="schemaPreviewTemplate"
                      :model="onBoarding"
                      :options="formOptions"
                    >
                    </vue-form-generator>
                  </div>
                </div>
                <div class="col-12" v-if="hasPermissions('superAdminTargets')">
                  <div class="float-right mr-5 px-"></div>
                </div>

                <div class="col-12">
                  <div class="m-3">
                    <button
                      v-if="!loading && hasPermissions('superAdminTargets')"
                      class="float-right btn rounded-circle ml-1 cursor-pointer btn-sm btn-primary"
                      @click="showModal('mails')"
                      type="button"
                    >
                      <i class="icon-expand"></i>
                    </button>
                    <button
                      v-if="!loading && hasPermissions('superAdminTargets')"
                      class="mr-2 float-right btn rounded-circle cursor-pointer btn-sm btn-secondary"
                      @click="editStep(1)"
                      type="button"
                    >
                      <i class="icon-pencil"></i>
                    </button>
                    <h5 class="d-inline">
                      {{ $t("lang.orders.sequence") }}
                    </h5>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div
                  v-if="
                    !loading &&
                      verificationOrder.status == 1 &&
                      previewTemplate()
                  "
                >
                  <TargetStepCampaingPreview
                    v-if="onBoarding.modelCampaingStep.tabSelected.id == 1"
                    :model="onBoarding.modelCampaingStep"
                    :availableTokens="availableTokens"
                    :preview="true"
                    :sequences_IA="sequences_IA"
                    :availableTokensSelect="availableTokens"
                  />

                  <PreviewEmail
                    class="p-4"
                    :tag_id="Number(tag_id)"
                    :templateId="1"
                    v-else
                    :resumed="true"
                    :subject="'Re'"
                  />
                </div>

                <div v-else>
                  <div class="text-center">
                    <span class="mb-4">
                      <img
                        width="20%"
                        src="@/assets/images/Logo-oliver-400.png"
                        class="d-block mx-auto my-2"
                      />
                      <>{{ $t("lang.onBoarding.questionsleft") }}</></span
                    >
                  </div>
                  <div class="text-center" v-if="false">
                    <button @click="goToSubStep(1, 1)" class="btn btn-primary">
                      {{ $t("lang.onBoarding.gotostep", { step: "1/3" }) }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 mb-4">
            <div class="card">
              <div class="row">
                <div class="col-12">
                  <div class="m-3">
                    <h5 class="d-inline">
                      {{ $t("lang.onBoarding.targeting_criteria") }}
                    </h5>
                    <button
                      class="float-right btn rounded-circle ml-1 cursor-pointer btn-sm btn-primary"
                      v-if="!disabledEdit()"
                      @click="showModal('targets')"
                      type="button"
                    >
                      <i class="icon-expand"></i>
                    </button>
                    <button
                      class="mr-2 float-right btn rounded-circle cursor-pointer btn-sm btn-secondary"
                      v-if="
                        (!disabledEdit() && false) || currentUser.role_id == 1
                      "
                      @click="editStep(2)"
                      type="button"
                    >
                      <i class="icon-pencil"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <LoadingSpinner v-if="step2SummaryLoading" />

                <div v-else-if="step2SummaryReady">
                  <Step2Summary
                    @change="refreshTarget($event)"
                    :key="'step2-' + onBoarding.orderId + '-' + step2sum"
                    :selectDisable="disabledEdit()"
                    @save="savenow(false, false)"
                  />
                </div>
                <div v-if="false && !onBoarding.step2Ready && !simplify">
                  <div class="text-center">
                    <span class="mb-4">{{
                      $t("lang.onBoarding.searchcriteria")
                    }}</span>
                  </div>
                  <div class="text-center">
                    <button @click="goToSubStep(2, 1)" class="btn btn-primary">
                      {{ $t("lang.onBoarding.gotostep", { step: "2/3" }) }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="text-center" v-if="!simplify && !addOrder">
          <button
            class="btn large cursor-pointer font-weight-bolder btn-sm btn-outline-dark mx-1 px-4"
            type="button"
            v-if="false"
            @click="goToSubStep(2, 1)"
          >
            {{ $t("lang.button.back") }}
          </button>
          <button
            class="btn large cursor-pointer font-weight-bolder btn-sm btn-primary mx-1 my-1 px-4 mt-4"
            type="button"
            @click="validate()"
            v-if="canSubmitForValidation && !simplify"
          >
            {{ $t("lang.onBoarding.start_preparing_my_campaigns") }}
            <span class="img-btn">
              <img src="@/assets/images/icono-wp.png" alt />
            </span>
          </button>
        </div>
      </div>
    </section>
    <div ref="swalTemplate" v-if="showModalStopTarget">
      <p class="h4 text-bold text-left">
        Why do you neet to stop this order ?
      </p>
      <select
        class="form-control"
        v-model="stopReason"
        :disabled="loadingTargetPreparing"
      >
        <option v-for="(reason, i) in stopReasons" :key="i" :value="reason">
          {{ reason }}
        </option>
      </select>

      <p class="mt-4 h4  text-left text-bold">
        What we do with prospecting emails ?
      </p>

      <select
        class="form-control"
        v-model="actionToProspectingEmails"
        :disabled="loadingTargetPreparing"
      >
        <option
          v-for="(order, i) in ordersPreparing"
          :key="i"
          :value="order.id"
        >
          {{ order.name }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>

import Fieldset from "@/components/Common/Fieldset.vue";
import TargetCampaigns from "@/components/Campaigns/TargetCampaigns.vue";
import TargetNote from "@/components/Targets/TargetNote";
import Tips from "@/components/Common/Tips.vue";
import MailsModal from "@/components/Onboarding/MailsModal.vue";
import Tabs from "@/components/Common/Tabs.vue";
import Modal from "@/components/Common/Modal.vue";
import Step1Summary from "@/components/Onboarding/MultiSteps/Step1Summary.vue";
import TargetsModal from "@/components/Onboarding/TargetsModal.vue";
import Step2Summary from "@/components/Onboarding/MultiSteps/Step2Summary.vue";
import TeamMembers from "@/components/Onboarding/TeamMembers.vue";
import TargetSequences from "@/components/Onboarding/TargetSequences.vue";
import { mapState, mapActions, mapGetters } from "vuex";
import PreviewEmail from "@/components/Emails/PreviewEmail.vue";
import PreviewSequencesEmail from "@/components/Emails/PreviewSequencesEmail.vue";
import TargetStepCampaingPreview from "@/components/Campaigns/TargetStepCampaingPreview.vue";
import CustomMsg from "@/components/AccountCreation/Steps/Campaign/CustomMsg.vue";
import CreditCardForm from "@/components/Billing/CreditCardForm.vue";
import VueFormGenerator from "vue-form-generator";
import Prospectors from "@/components/Targets/Prospectors.vue";
import moment from "moment";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import StatusComment from "@/components/Common/StatusComment";
import IndustrySearch from "@/components/AccountCreation/Steps/Campaign/search/IndustrySearch.vue";
import Tooltip from "@/components/Common/Tooltip.vue";
import VideoToolToy from "@/components/Onboarding/VideoToolToy.vue";
import GraphOfStats from "@/components/Dashboard/GraphOfStats.vue";
import CampaignsEmails from "@/components/Campaigns/CampaignsEmails.vue";
import CampaignsEmailsByStep from "@/components/Campaigns/CampaignsEmailsByStep.vue";
import Profitability from "@/components/Campaigns/Profitability.vue";
import BillingToOrder from "@/components/Campaigns/BillingToOrder.vue";
import ColdCallScript from "@/components/Onboarding/ColdCallScript.vue";
import ListSDRTeam from "@/components/SalesRepresentative/ListSDRTeam.vue";
import { targetsService, usersService, adminService, clientsService } from "@/_services";
import {
  CONTACTS_PER_SALE,
  getIdealNumberOfSalesByResult as calcIdealSalesCount,
  isValidSalesQuantity as checkSalesQuantity,
  getSalesQuantityBlockReason,
} from "@/_helpers/orderSalesQuantity";
import { setTimeout } from "timers";
import SpecialDiscountOrderNotification from "@/components/SpecialDiscountOrderNotification.vue";
import { formattersMixin } from "@/_mixins/";
import { targetSequencesService } from "../../../_services/targetsequences.service";
import AllEmails from "@/components/Emails/AllEmails.vue";
import BookerOverview from "@/components/BDR/BookerOverview.vue";
import BdrTasks from "@/components/BDR/BdrTasks.vue";
import ProspectorsVue from "../../Targets/Prospectors.vue";
import Diagnostic from "@/components/Targets/Diagnostic.vue";
import TargetContactImport from "@/components/Onboarding/TargetContactImport.vue";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { on } from "events";

export default {
  data() {
    var self = this;

    return {
      shouldCcallTarget: "0",
      contactSource: 0,
      actionToCall: [
        {id: "0", label: "No"},
        {id: "1", label: "Yes"},
      ],
      contactSourceOptions: [
        {id: 0, label: "No"},
        {id: 1, label: "Yes"},
      ],
      savingOrderType: false,
      generatingColdCallSpec: false,
      bdrsSelected:[],
      bdr_users:[],
      audience_description: "",
      audience_items: [
        "SaaS Solutions (management software, ERP, CRM, etc.)",
        "Consulting Services (strategy, marketing, finance, human resources, etc.)",
        "Technology Equipment (IT equipment, servers, networks, etc.)",
        "Industrial Supplies (production equipment, machine tools, etc.)",
        "Professional Training (personal development, sales techniques, management, etc.)",
        "HR Services (recruitment, personnel outsourcing, talent management, etc.)",
        "Digital Marketing (advertising agencies, SEO/SEM optimization, social media management, etc.)",
        "Logistics and Transport (shipment management solutions, freight services, etc.)",
        "Financial Services (treasury management, banking services, insurance, etc.)",
        "Cybersecurity Solutions (risk management, data protection, etc.)",
        "Legal Services (compliance management, business law advice, etc.)",
        "Energy Services (energy audit, cost optimization, etc.)",
        "Office Equipment (furniture, office supplies, workspace solutions, etc.)",
        "IT Services (infrastructure management, cloud computing, IT maintenance, etc.)",
        "Healthcare Supplies and Equipment (medical equipment, teleconsultation services, etc.)"
      ],
      permi: "",
      showModalStopTarget: false,
      categoryKey: "General_Management_Owners",
      stopTarget: false,
      loadingTargetPreparing: true,
      loadingOrderDataExport: false,
      newAvailableToken:[],
      actionToProspectingEmails: "delete",
      ordersPreparing: [
        {
          id: "delete",
          name: "Delete"
        },
        {
          id: "keep",
          name: "Keep emails"
        }
      ],
      total_contacts:0,
      stopReason: "Campaign > A/B testing",
      stopReasons: [
        "Campaign > A/B testing",
        "Campaign > Launching delay",
        "App > Not enough results",
        "App > Doesn't fit needs",
        "App > Trust issue (meeting reporting)",
        "App > Trust issue (bugs)",
        "App > Global dissatisfaction",
        "Client > Company closure",
        "Client > ROI issue",
        "Client > Cash flow issue",
        "Client > Team structure issue",
        "Client > Engagement issue",
        "Client > Indefinite pause",
        "Client > No longer need app",
        "Client > Payment issue",
        "Client > Unreachable",
        "Client > Churn before AM",
        "Client > Client auto deletion",
        "Client > Other issue"
      ],
      duplicateReason: null,
      editingUrl: false,
      previewEmail: false,
      flags: [
        { id: "fr", lang_id: 1, text: "fr.svg" },
        { id: "en", lang_id: 2, text: "us.svg" },
        { id: "es", lang_id: 3, text: "es.svg" },
        { id: "it", lang_id: 4, text: "it.svg" },
        { id: "pt", lang_id: 5, text: "pt.svg" }
      ],
      showMessages: [],
      tabSelected: 1,
      duplicate_reason: null,
      emptySequence: false,
      regenerateEmail: false,
      sequences_IA: [],
      tabs1: {},
      modelCampaingStep: {
        campaign: {
          is_agency: 1
        },
        campaign_steps: []
      },
      formValidation: {
        urlIsValid: false,
        appointment: false
      },
      training_check: false,
      trainingCheck_2: false,
      trainingCheck_3: false,
      training_step1: false,
      sequences_IA_loading: false,
      oliverEmailSequence: false,
      loadingEmailSequence: false,
      editing: [],
      tabSelect: 1,
      verificationOrder: [],
      step2sum: 2322,
      targetkey: 232232,
      select_list_sizes: [
        { id: 0, label: "1-10" },
        { id: 1, label: "11-20" },
        { id: 2, label: "21-50" },
        { id: 3, label: "51-100" },
        { id: 4, label: "101-200" },
        { id: 5, label: "201-500" },
        { id: 6, label: "501-1000" },
        { id: 7, label: "1001-2000" },
        { id: 8, label: "2001-5000" },
        { id: 9, label: "5001-10000" },
        { id: 10, label: "10001+" }
      ],
      apolloResult: false,
      editPrice: false,
      salesRep: [],
      isDisabled: true,
      loadingSales: true,
      saving: false,
      selected_sizes: [],
      selectedSales: [],
      activeLanguage: "",
      language: "",
      select_offer_prospect: [
        {
          id: 1,
          label: this.$t("lang.onBoarding.offer_1")
        },
        {
          id: 2,
          label: this.$t("lang.onBoarding.offer_2")
        },
        {
          id: 3,
          label: this.$t("lang.onBoarding.offer_3")
        },
        {
          id: 4,
          label: this.$t("lang.onBoarding.offer_4")
        }
      ],
      langs: [
        {
          id: 1,
          type: "fr",
          label: this.$t("lang.onBoarding.lang.french")
        },
        {
          id: 2,
          type: "en",
          label: this.$t("lang.onBoarding.lang.english")
        },
        {
          id: 3,
          type: "es",
          label: this.$t("lang.onBoarding.lang.spanish")
        },
        {
          id: 4,
          type: "it",
          label: this.$t("lang.onBoarding.lang.italian")
        },
        {
          id: 5,
          type: "pt",
          label: this.$t("lang.onBoarding.lang.portuguese")
        }
      ],
      optionSales: [],
      sales: [],
      showTarget: true,
      step1hasError: false,
      editingAppointPrice: false,
      mailmodalkey: 2123,
      emailDataToken: [],
      modelform: {
        launchDate: null,
        sales: [],
        website: null,
        descriptionSell: null,
        oldTargetId: null
      },
      schemaStatus: {
        fields: [
          {
            type: "input",
            inputType: "date",
            model: "launchDate",
            featured: true,
            required: true,
            validator: VueFormGenerator.validators.date.locale({
              dateIsEarly: this.$t("lang.onBoarding.dateIsEarly")
            }),
            format: "YYYY-MM-DD",
            min: moment().startOf("day").format("YYYY-MM-DD")
          }
        ]
      },
      schemaWebsite: {
        fields: [
          {
            type: "input",
            inputType: "text",
            styleClasses: "my-0 py-0",
            model: "website",
            featured: true,
            required: true
          }
        ]
      },
      schemaSales: {
        fields: [
          {
            type: "vueMultiSelect",
            model: "sales",
            label: this.$t("lang.onBoarding.who_is_thesales"),
            values: this.selectedSales,
            multiSelect: true,
            selectOptions: {
              multiple: true,
              trackBy: "id",
              label: "first_name",
              taggable: false,
              searchable: false,
              closeOnSelect: false,
              hideSelected: true,
              value: "id",
              name: "first_name"
            }
          }
        ]
      },
      schemaPreviewTemplate: {
        fields: [
          {
            type: "switch",
            label: this.$t("lang.onBoarding.previewtemplate"),
            model: "previewTemplate",
            featured: true,
            id: "previewTemplate",
            textOn: " ",
            textOff: " ",
            valueOn: "1",
            valueOff: "0",
            styleClasses: "col-md-12 display-inline",
            visible() {
              return self.currentUser.role_id == 1;
            }
          }
        ]
      },
      schemaCloseOrder: {
        fields: [
          {
            type: "switch",
            label: this.$t("lang.orders.order_finished"),
            model: "closed",
            featured: true,
            id: "closed",
            textOn: " ",
            textOff: " ",
            valueOn: "1",
            valueOff: "0",
            styleClasses: "col-md-12 display-inline",
            visible() {
              return self.hasPermissions("superAdminTargets");
            }
          }
        ]
      },
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true
      },
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true
      }
    };
  },
  watch: {
    "modelform.website"(newValue) {
      if (newValue.includes("linkedin")) {
        this.formValidation.urlIsValid = true;
      } else {
        this.formValidation.urlIsValid = false;
      }
    },
    "modelform.website"(newValue) {
      if (newValue > 10) {
        this.formValidation.urlIsValid = true;
      } else {
        this.formValidation.urlIsValid = false;
      }
    },
    isCopyTarget(newValue) {
      if (newValue) {
        this.savenow(false, false, false);
      }
    },
    targetWasLoaded(newValue) {

      if (newValue) {
        if (this.$route.query.save && this.$route.query.sales && this.$route.query.oldTargetId) {
        //if (this.$route.query.save && this.$route.query.sales) {

          this.sales = JSON.parse(this.$route.query.sales);

          const  oldTargetId = JSON.parse(this.$route.query.oldTargetId);

          this.sales.forEach( el => {

            if(!this.modelform.sales.includes(el)){
              this.modelform.sales.push(el)
            }
          })

          this.modelform.oldTargetId = oldTargetId

          this.$swal({
            icon: "warning",
            title: this.$t("lang.orders.assign_sale_to_order"),
            text: this.$t("lang.search.waitplease"),
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false
          });

          const redictoToOtherTarget = {
            redirect: false,
            stayOnPage: true
          };

          setTimeout(() => {
            this.savenow(false, false, redictoToOtherTarget);
          }, 3000);

          //this.savenow(false, false, redictoToOtherTarget);
        }
        this.bdrsSelected = this.onBoarding.bookers;
        this.shouldCcallTarget = this.onBoarding.should_call_target;
        this.contactSource = this.onBoarding.contact_source;

      }
    }
  },
  computed: {
    ...mapState({
      availableTokens: state => state.optionsList.all["available_tokens"],
      completeLoadingTarget: state => state.optionsList.completeLoadingTarget,
      readyToPrepear: state => state.onboarding.readyToPrepear,
      onBoarding: state => state.onboarding,
      targetWasLoaded: state => state.onboarding.targetWasLoaded,
      loadingGetApollo: state => state.onboarding.isDisable,
      target_status_id: state => state.onboarding.target_status_id,
      tabs: state => state.onboarding.tabs,
      tag_id: state => state.onboarding.step3.tag_id,
      loading: state => state.onboarding.loading,
      size: state => state.onboarding.size,
      currentUser: state => state.authentication.user,
      isMenuCollapse: state => state.sidebar.isNavOpen,
      isCopyTarget: state => state.onboarding.isCopyTarget,
      tag_2: state => state.optionsList.all["tag_2"],
      categories_jobs_group: state =>
        state.optionsList.all["category_jobs_group"].data
    }),
    ...mapGetters('authentication', ['isSaleOrAccountExecutive']),
    canSubmitForValidation() {
      return !this.hasPermissions(["sale", "billing"]);
    },
    selectedSalesRep()
    {
      return this.salesRep.filter(rep => this.modelform.sales.includes(rep.id));
    },
    step2SummaryLoading() {
      return Number(this.onBoarding.orderId) > 0 && this.onBoarding.loading;
    },
    step2SummaryReady() {
      if (!Number(this.onBoarding.orderId)) {
        return true;
      }
      return !this.onBoarding.loading;
    },
    isActivationOrder() {
      return this.onBoarding.order_type === "activation";
    },
    targetingContactsTotal() {
      if (this.isActivationOrder) {
        return this.onBoarding.activationContactsCount || 0;
      }
      if (this.onBoarding.apollo && this.onBoarding.apollo.total_result > 0) {
        return this.onBoarding.apollo.total_result;
      }
      if (this.onBoarding.total_contacts && this.onBoarding.total_contacts > 0) {
        return this.onBoarding.total_contacts;
      }
      return 0;
    },
    orderTypeLocked() {
      return (
        this.savingOrderType ||
        this.disabledEdit() ||
        (this.onBoarding.orderId && Number(this.target_status_id) !== 3) ||
        (this.onBoarding.orderId && Number(this.onBoarding.linkedContactsCount) > 0)
      );
    },
    orderTypeLockMessage() {
      if (
        this.onBoarding.orderId &&
        Number(this.onBoarding.linkedContactsCount) > 0
      ) {
        return this.$t("lang.orders.order_type_change_locked_contacts");
      }
      if (this.onBoarding.orderId && Number(this.target_status_id) !== 3) {
        return this.$t("lang.orders.order_type_change_locked_status");
      }
      return null;
    },
    // Safe accessor for questions data
    questionsData() {
      if (!this.onBoarding || !this.onBoarding.questions || !this.onBoarding.questions.data) {
        return [];
      }
      return this.onBoarding.questions.data;
    },

    characterResponseCounter() {
      return (question, answer, total) => {
        const questionData = this.getQuestionById(question);
        if (!questionData || !questionData.answers || !questionData.answers[answer - 1]) {
          return `${this.$t("lang.label.charactersavailable", {
            actual: 0,
            total
          })}`;
        }
        const text = questionData.answers[answer - 1].text || '';
        return `${this.$t("lang.label.charactersavailable", {
          actual: text.length,
          total
        })}`;
      };
    },
    isUserOperational() {
      return (
        this.currentUser.role_id == 1 &&
        this.currentUser.user_constraint_id == 1
      );
    },
    isUserAccountManager() {
      return (
        this.currentUser.role_id == 1 &&
        this.currentUser.user_constraint_id == 2
      );
    },
    skipSalesQuantityValidation() {
      return (
        this.currentUser.role_id == 1 &&
        this.currentUser.user_constraint_id == 2
      );
    },
    flagActually() {
      return id => {
        if (id) {
          const flag = this.flags.find(e => e.lang_id == id).text;
          return require("@/assets/images/flags/" + flag);
        } else {
          if (this.onBoarding.lang != "") {
            const flag = this.flags.find(
              e => e.lang_id == this.onBoarding.language_id
            ).text;
            return require("@/assets/images/flags/" + flag);
          } else {
            return require("@/assets/images/flags/fr.svg");
          }
        }
      };
    },
    getLangSelected() {
      let lang = null;
      if (this.onBoarding.language_id != "") {
        lang = this.langs.find(e => e.id == this.onBoarding.language_id).label;
      } else {
        lang = this.langs.find(e => e.type == "fr").label;
      }
      return lang;
    },
    textQtyCharacters() {
      const qty = this.onBoarding.descriptionSell
        ? this.onBoarding.descriptionSell.length
        : 0;
      return `( ${qty} / 2000 )`;
    },
    correctNumberCharacters() {
      const qty = this.onBoarding.descriptionSell
        ? this.onBoarding.descriptionSell.length
        : 0;
      return qty > 2000 ? false : true;
    },
    isSpecialOrderDiscountActive() {
      let client_creation_date =
        this.onBoarding.client_creation_date === undefined ||
        this.onBoarding.client_creation_date === ""
          ? this.currentUser.client_creation_date
          : this.onBoarding.client_creation_date;
      return this.isPromotionActive(client_creation_date, 168).isActive; // promotion7days
    },
    availableStopSendingForThisMonth() {
      return (
        parseInt(this.onBoarding.total_meetings_this_month) >=
        parseInt(this.onBoarding.step3.appointmentVolume)
      );
    }
  },

  components: {
    Diagnostic,
    ColdCallScript,
    Prospectors,
    TargetCampaigns,
    Fieldset,
    IndustrySearch,
    MailsModal,
    LoadingSpinner,
    Step1Summary,
    TargetsModal,
    Step2Summary,
    TeamMembers,
    PreviewEmail,
    PreviewSequencesEmail,
    TargetStepCampaingPreview,
    Modal,
    StatusComment,
    CreditCardForm,
    VideoToolToy,
    CustomMsg,
    Tabs,
    Tooltip,
    Tips,
    TargetSequences,
    GraphOfStats,
    CampaignsEmails,
    CampaignsEmailsByStep,
    "vue-form-generator": VueFormGenerator.component,
    SpecialDiscountOrderNotification,
    Profitability,
    BillingToOrder,
    ListSDRTeam,
    TargetNote,
    AllEmails,
    BookerOverview,
    BdrTasks,
    TargetContactImport,
    Treeselect,
  },
  props: {
    simplify: Boolean,
    addOrder: Boolean,
    targetId: false,
    typeForm: false
  },
  beforeMount() {
    this.verificationOrder = this.onBoarding.validationTarget;
    this.verificationOrder.target_id = this.targetId;

  },
  updated() {
    this.categories_jobs_group.map(element => {
      if (this.onBoarding.audience == element.category) {
        this.categoryKey = element.category;
      }
    });

    this.audience_items.map(element => {
      if (this.onBoarding.audience_description == element) {
        this.audience_description = element;
      }
    });
    this.duplicate_reason = this.onBoarding.step3.duplicate_reason;
  },
  mounted() {
    this.loadActivationContactsStats();
    if (this.availableTokens && this.availableTokens.data) {
      this.newAvailableToken = this.availableTokens.data.filter((item)=>{
        if(item.name == 'prospect_first_name' || item.name == 'my_calendar_link' || item.name == 'prospect_company_name' || item.name == 'prospect_last_name'){
          return item
        }
      })
    } else {
      this.newAvailableToken = []
    }
    this.tabs1 = {
      1: {
        id: 1,
        name: this.$t("lang.orders.parameters"),
        paymentStatusId: 0
      },
      2: {
        id: 2,
        name: this.$t("lang.orders.your_services"),
        paymentStatusId: 2
      },
      3: {
        id: 3,
        name: this.$t("lang.orders.your_targeting"),
        paymentStatusId: 3
      },
      4: {
        id: 4,
        name: this.$t("lang.orders.your_sequence"),
        paymentStatusId: 4
      },
      5: {
        id: 5,
        name: "Cold Call Script",
        permission:
          (this.hasPermissions("superAdmin") ||  this.hasPermissions("noAdminBilling")  ) && !this.isUserOperational
            ? true
            : "no"
      },
      6: {
        id: 6,
        name: "Statistics",
        permission:
          this.hasPermissions("superAdmin") && !this.isUserOperational
            ? true
            : "no"
      },
      7: {
        id: 7,
        name: this.$t("lang.menu.contacts"),
        permission:
          this.hasPermissions("superAdmin") && !this.isUserOperational
            ? true
            : "no"
      },
      8: {
        id: 8,
        name: "Profitability",
        permission:
          this.hasPermissions("superAdmin") && !this.isUserOperational
            ? true
            : "no"
      },
      9: {
        id: 9,
        name: "Billing",
        permission:
          this.hasPermissions("superAdmin") && !this.isUserOperational
            ? true
            : "no"
      },
      10: {
        id: 10,
        name: this.$t("lang.menu.email_account"),
        permission:
          this.hasPermissions("superAdmin") && !this.isUserOperational
            ? true
            : "no"
      },
      11: {
        id: 11,
        name: "Campaigns Health",
        permission:
          this.hasPermissions("superAdmin") && !this.isUserOperational
            ? true
            : "no"
      },
      12: {
        id: 12,
        name: "Inbox",
        permission:
          this.hasPermissions("superAdmin") && !this.isUserOperational
            ? true
            : "no"
      },
      13: {
        id: 13,
        name: "Diagnostic",
        permission:
          this.hasPermissions("superAdmin") && !this.isUserOperational
            ? true
            : "no"
      },
      14: {
        id: 14,
        name: "Booker Timing",
        permission:
          this.hasPermissions("superAdmin") && !this.isUserOperational
            ? true
            : "no"
      },
      15: {
        id: 15,
        name: "Booker Tasks",
        permission:
          this.hasPermissions("superAdmin") && !this.isUserOperational
            ? true
            : "no"
      }
    };
    if (this.onBoarding.lang == null || this.onBoarding.lang == "") {
      this.setLanguageId(this.currentUser.language_id);
    }
    this.loadingSales = true;
    this.getSales();
    //this.$modal

    //this.$modal.show('contractConfirmation');
    //this.contractConfirmation();

    //this.setStep(3);

    if (this.currentUser.role_id != 1 || this.currentUser.role_id != 5) {
      if (
        this.currentUser.saw_video == 0 &&
        this.currentUser.payment_method_confirmed == 1
      ) {
        this.$modal.show("videotraining");
      } else {
        if (this.onBoarding.conditionPayment == "error") {
          this.$modal.show("confirm");
        }
      }
    }
  },
  created() {


    this.getUserBdr()

    if (this.typeForm == "onboarding") {
      this.setTypeForm("onboarding");
    }

    // Cargar ambos: v1 usa endpoint viejo (plano), v2 usa endpoint jerarquía. Así al cambiar de versión cada IndustrySearch tiene su data.
    if (!this.completeLoadingTarget) {
      this.$store.dispatch("optionsList/getAllTargetParams");
    }
    this.$store.dispatch("optionsList/getCategoriesGoogleWithHierarchy");
    this.updateCompanyName(this.currentUser.client_name);
    this.setEmailDataToken();
    let defaultDate = this.formatDate();
    console.log("defaultDate", defaultDate);
    if (
      this.onBoarding.step3.launchDate == "" ||
      this.onBoarding.step3.launchDate == undefined
    ) {
      // this.updateLaunchDate(defaultDate);
      this.modelform.launchDate = defaultDate;
    }

    this.modelform.website = this.onBoarding.website;
    this.validateForm();

    if (this.onBoarding.orderName.length == 0) {
      this.updateOrderName("My order " + this.currentUser.name);
    }

    if(this.addOrder && this.hasPermissions("superAdmin") && !this.isSaleOrAccountExecutive)
    {
      //solo para oliver - recargar cuando crean un order y el endpoint gettarget muestre la info real del target
      const orderRoute = `/orders/${this.targetId}`;
      window.location.href = orderRoute;
    }

    if (!this.addOrder && this.simplify) {
      if (this.targetId) {
        this.loadTarget(this.targetId);
      }
    }

    this.changeLanguage();
    this.ReplaceModelform = this.modelform;
  },

  mixins: [formattersMixin],

  methods: {
    ...mapActions("onboarding", {
      setWarmupActive: "setWarmupActive",
      setCreateMailboxes: "setCreateMailboxes",
      setAudience: "setAudience",
      setAudienceDescription: "setAudienceDescription",
      setOrderType: "setOrderType",
      setActivationContactsCount: "setActivationContactsCount",
      setActivationContactsStats: "setActivationContactsStats",
      updateDuplicateReason: "updateDuplicateReason",
      setLoading: "setLoading",
      getApollo: "getApollo",
      setDisabledTab: "setDisabledTab",
      setCampaingSteps: "setCampaingSteps",
      setOrderData: "setOrderData",
      setEmailDataToken: "setEmailDataToken",
      loadTarget: "loadTarget",
      copy: "copy",
      setStep: "goToStep",
      setSubStep: "goToSubStep",
      setTab: "setTab",
      setIsCopyTarget: "setIsCopyTarget",
      setTabStep3: "setTabStep3",
      updateAppointmentVolume: "updateAppointmentVolume",
      updateLaunchDate: "updateLaunchDate",
      updatePositions: "updatePositions",
      updateDepartments: "updateDepartments",
      updateCountry: "updateCountry",
      updateRegion: "updateRegion",
      updateSizes: "updateSizes",
      updatePrice: "updatePrice",
      updateAdminPrice: "updateAdminPrice",
      updateNewEmailsPerDay: "updateNewEmailsPerDay",
      updateTotalEmailsPerDay: "updateTotalEmailsPerDay",
      updatePreviewTemplate: "updatePreviewTemplate",
      updateSectorsExclude: "updateSectorsExclude",
      updateCategoryJobs: "updateCategoryJobs",
      updateSectorsInclude: "updateSectorsInclude",
      updateProductName: "updateProductName",
      updateOrderName: "updateOrderName",
      updateBenefitsOffer: "updateBenefitsOffer",
      updateOfferAttractive: "updateOfferAttractive",
      updateDescriptionSell: "updateDescriptionSell",
      updateDescriptionOrder: "updateDescriptionOrder",
      updateColdCallspec: "updateColdCallspec",
      updateWebsite: "updateWebsite",
      updateQuestions: "updateQuestions",
      updateTargetStatusId: "updateTargetStatusId",
      setOrderId: "setOrderId",
      changeLang: "changeLangAction",
      setLanguageId: "setLanguageId",
      updateServiceDescription: "updateServiceDescription",
      addTeamMember: "addTeamMember",
      clearTeamMember: "clearTeamMember",
      updateTagId: "updateTagId",
      cleanOnboarding: "clean",
      updateOfferProspect: "updateOfferProspect",
      save: "save",
      updateCompanyName: "updateCompanyName",
      setTypeForm: "setTypeForm",
      updateSales: "updateSales",
      validateForm: "validateForm",
      validateStep: "validateStep",
      setIsMonthlyPaused: "setIsMonthlyPaused",
      setHoursPaused: "setHoursPaused"
    }),

    normalizeOptions(node) {
      return {
        id: node.id,
        label: node.name,
      };
    },

    getUserBdr() {
      const statuses = '5,10'
      const filterBoookerWithoutOrder = 0
      const target_id = this.targetId
      const additional_data = 1

      usersService
        .getBdrs(statuses, filterBoookerWithoutOrder, target_id, additional_data)
        .then((res) => {
          if(res.result.length > 0 ) {
            this.bdr_users = res.result.map( el => {
              return {
                ...el,
                name: el.name + " - " + el.cold_meeting_rate + " - " + el.hours_worked
              }
            });
          } else {

            this.bdr_users = res.result;
          }


        })
        .catch((err) => consolelog(err));
    },

    onActivationContactsChanged(stats) {
      if (stats && typeof stats === "object") {
        this.setActivationContactsStats(stats);
      } else {
        this.setActivationContactsCount(stats);
      }
      this.total_contacts =
        stats && typeof stats === "object" ? stats.total : stats;
    },
    loadActivationContactsStats() {
      if (!this.isActivationOrder || !this.onBoarding.orderId) {
        return Promise.resolve();
      }
      return targetsService
        .getActivationContactsStats(this.onBoarding.orderId)
        .then((response) => {
          if (response) {
            this.setActivationContactsStats(response);
          }
        })
        .catch(() => {});
    },
    addSalesRep(id) {
      this.total_contacts = this.targetingContactsTotal;

      if (!this.modelform.sales.includes(id)) {
        this.modelform.sales.push(id);
        this.updateSales(this.modelform.sales);
      }
    },

    removeSales(id)
    {
      this.$swal({
          type: "warning",
          title: this.$t("lang.button.deleteteam"),
          text: this.$t("lang.label.areyousure"),
          showConfirmButton: true,
          showCancelButton: true,
          confirmButtonColor: "#81c784",
          cancelButtonColor: "#d33a2c",
      }).then((result) =>
      {
        if(result.value)
        {
          this.modelform.sales = this.modelform.sales.filter(saleId => saleId !== id);
          this.updateSales(this.modelform.sales);
        }
      })
    },

    showModalTips() {
      this.$modal.show("modalTips");
    },

    isSelected(id) {
      return this.modelform.sales.includes(id); // Devuelve true si ya está seleccionado
    },

    salesInboxTotals(item) {
      const active = Number(item.total_active) || 0;
      const warming_up = Number(item.total_warming_up) || 0;
      const stopped = Number(item.total_stopped) || 0;
      const not_first_sync = Number(item.total_not_first_sync) || 0;
      return {
        active,
        warming_up,
        stopped,
        not_first_sync,
        total: active + warming_up + stopped
      };
    },

    getTargetsByClientAndStatus(client_id, target_status_id) {
      this.loadingTargetPreparing = true;
      targetsService
        .getTargetsByClientAndStatus(client_id, target_status_id)
        .then(response => {
          if (response) {
            if (response.result) {
              const targetList = response.result.map(el => {
                return {
                  ...el,
                  name: "Assign to: " + el.name
                };
              });
              this.ordersPreparing = [
                {
                  id: "delete",
                  name: "Delete"
                },
                {
                  id: "keep",
                  name: "Keep emails"
                }
              ];

              this.ordersPreparing.push(...targetList);
              this.targetId;

              this.ordersPreparing = this.ordersPreparing.filter(
                el => el.id != this.targetId
              );
            }
          }
          this.loadingTargetPreparing = false;
        });
    },

    modalContractConfirmation(value) {
      if (value === "hide") {
        this.$modal.hide("contractConfirmation");
      } else {
        if (value === "yes") {
          this.$modal.hide("contractConfirmation");
          this.$modal.show("confirm");
          //this.$modal.show("videotraining");
        } else {
          this.$modal.show("contractConfirmation");
        }
      }
    },

    showInputMessage(question, answer) {
      const answerFound = this.showMessages.find(
        e => e.question === question && e.answer === answer
      );
      if (answerFound) {
        if (answerFound.status === "enable") {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    showMessage(question, status, answer) {
      const findAnswer = this.showMessages.findIndex(
        e => e.question === question && e.answer === answer
      );
      if (findAnswer >= 0) {
        this.showMessages.find(
          e => e.question === question && e.answer === answer
        ).status = status;
      } else {
        this.showMessages.push({
          question: question,
          answer: answer,
          status: status
        });
      }
    },
    getQuestionById(questionId) {
      if (!this.questionsData || !Array.isArray(this.questionsData)) {
        return null;
      }
      return this.questionsData.find(e => e.question === questionId);
    },
    getQuestionAnswer(questionId, answerIndex) {
      const question = this.getQuestionById(questionId);
      if (!question || !question.answers || !question.answers[answerIndex]) {
        return '';
      }
      return question.answers[answerIndex].text || '';
    },
    changeQuestions(e, question = null, answer = null) {
      const data = {
        input: e.target.value,
        question: question,
        answer: answer
      };
      this.updateQuestions(data);
    },
    changeLink(e) {
      this.updateWebsite(e.target.value);
    },
    isOpen(type) {
      return this.editing[type] !== undefined && this.editing[type] == true;
    },
    changeTagId(e) {
      this.updateTagId(e.target.value);
    },
    changeOfferProspect(e) {
      this.updateOfferProspect(e.target.value);
    },
    openEdit(type) {
      if (type == "website") {
        this.modelform.website = this.onBoarding.website;
      }
      if (type == "launchDate") {
        this.modelform.launchDate = this.onBoarding.step3.launchDate;
      }
      this.editing[type] = true;
      this.$forceUpdate();
    },
    closeEdit(type) {
      if (type === "price") this.editingAppointPrice = false;
      this.savenow(false, false);
      this.editing[type] = false;
      this.$forceUpdate();
    },
    hasPermissions(perm) {
      if (!this.$store.getters["authentication/hasPermissions"]) {
        return false;
      }
      return this.$store.getters["authentication/hasPermissions"](perm);
    },
    onOrderTypeChange(event) {
      const newOrderType = event.target.value;
      const previousOrderType = this.onBoarding.order_type;

      if (newOrderType === previousOrderType) {
        return;
      }

      this.setOrderType(newOrderType);

      if (!this.onBoarding.orderId) {
        return;
      }

      this.savingOrderType = true;
      targetsService
        .updateTargetOrderType(this.onBoarding.orderId, newOrderType)
        .then(() => {
          this.savingOrderType = false;
        })
        .catch((err) => {
          this.setOrderType(previousOrderType);
          event.target.value = previousOrderType;
          this.savingOrderType = false;
          this.$swal({
            type: "error",
            title: this.$t("lang.label.error"),
            text:
              (err && err.message) ||
              this.$t("lang.orders.order_type_change_error"),
          });
        });
    },
    disabledEdit() {
      //1 > active or prepearing
      //2 > stop or inactive
      //3 > pending
      //4 > running
      //5 > archived

      // if (
      //   this.hasPermissions("adminClients") &&
      //   this.onBoarding.target_status_id != 4
      // ) {

      if (
        this.hasPermissions("adminClients")
      ) {
        return false;
      }

      return (
        this.target_status_id == 4 ||
        this.target_status_id == 2 ||
        this.target_status_id == 1
      );
    },
    disabledEditSales() {
      //1 > active or prepearing
      //2 > stop or inactive
      //3 > pending
      //4 > running
      //5 > archived
      //if (this.hasPermissions("adminClients") && this.target_status_id != 4) {
      if (this.hasPermissions("adminClients") ) {
        return false;
      }

      return this.target_status_id == 4 || this.target_status_id == 1;
    },
    previewTemplate() {
      return (
        (this.onBoarding.previewTemplate == 1 &&
          this.typeForm != "onboarding") ||
        this.currentUser.role_id == 1
      );
    },
    isStatusPending() {
      //1 > active
      //2 > stop
      //3 > pending
      return (
        (this.target_status_id == 3 || this.target_status_id == 1) &&
        !this.addOrder
      );
    },
    goToSubStep(step, substep) {
      this.setStep(step);
      this.setSubStep(substep);
    },
    editStep(step) {
      if (this.typeForm == "onboarding") {
        this.goToSubStep(step, 1);
      } else {
        if (step == 1) this.showModal("mails");
        else if (step == 2) this.showModal("targets");
      }
    },
    showModal(modal) {
      this.$modal.show(modal);
      if (modal == "targets") {
        this.showTarget = false;
        this.targetkey++;
      }
    },
    refreshTarget(result) {
      this.apolloResult = result;
      this.targetkey++;
    },
    closeModal(modal) {
      if (modal == "targets") {
        this.step2sum++;
      }
      this.$modal.hide(modal);
      //}
      this.showTarget = true;
    },
    openModal(modal) {
      this.$modal.show(modal);
    },
    emptyQuestions() {
      return !this.onBoarding.step1Ready && this.previewTemplate();
    },


    getIdealNumberOfSalesByResult(total_result) {
      return calcIdealSalesCount(total_result);
    },

    getTotalEmailPerDay() {
      let sales_quantity = 0;

      if (this.modelform.sales.length > 0) {
        sales_quantity = this.modelform.sales.length;
      } else {
        sales_quantity = this.onBoarding.step3.teamMembers.length;
      }

      return CONTACTS_PER_SALE * sales_quantity;
    },

    validSalesQuantity(pendingAdd = 0) {
      const salesCount =
        this.typeForm === "onboarding"
          ? this.onBoarding.step3.teamMembers.length
          : this.modelform.sales.length;

      return checkSalesQuantity(this.onBoarding, salesCount, pendingAdd);
    },

    salesQuantity() {
      return calcIdealSalesCount(this.targetingContactsTotal);
    },

    salesQuantityLimitMessage(blockReason) {
      if (blockReason === "no_contacts") {
        return this.$t("lang.onBoarding.errorquantitysales_no_contacts", {
          contacts: this.targetingContactsTotal,
        });
      }

      return this.$t("lang.onBoarding.errorquantitysales", {
        size: this.targetingContactsTotal,
        quantity: this.salesQuantity(),
      });
    },
    validate() {
      if (!this.isActivationOrder && this.onBoarding.apollo.total_result == 0) {
        this.getApollo();
      }

      const runValidation = () => {
        // Sales quantity is only enforced when adding a new SR (+), not on save.
        // Pre-existing assignments above the contact limit are grandfathered in.

        if (
          (this.onBoarding.step3.teamMembers.length == 0 &&
            this.onBoarding.typeForm == "onboarding") ||
          !this.validateForm()
        ) {
          this.$modal.show("Errors");
          return null;
        }

        if (
          (this.onBoarding.step3.updateSales.length == 0 &&
            this.onBoarding.typeForm != "onboarding") ||
          !this.validateForm()
        ) {
          this.$modal.show("Errors");
          return null;
        }

        if (this.currentUser.agency_signed == 0 && !this.simplify) {
          this.modalContractConfirmation("open");
        } else {
          if (this.onBoarding.typeForm == "onboarding") {
            this.modalContractConfirmation("open");
          } else {
            this.savenow(true, true);
          }
        }

        return false;
      };

      if (this.isActivationOrder) {
        return this.loadActivationContactsStats().then(runValidation);
      }

      return runValidation();
    },
    saveOrderClosed() {
      const { orderId, closed } = this.onBoarding;
      const data = {
        target_id: orderId,
        closed
      };
      targetsService
        .updatedOrderClosed(data)
        .then(res => {
          if (res.status === 200) {
            this.$swal({
              type: "success",
              title: this.$t("lang.label.great"),
              text: this.$t("lang.label.datasavedsuccessfully"),
              showConfirmButton: false,
              timer: 2000
            });
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title:
              err.status === 401
                ? this.$t("lang.general.permissiondenied")
                : this.$t("lang.label.error"),
            text:
              err.status === 401
                ? this.$t("lang.general.permissiondenied")
                : this.$t("lang.label.error"),
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            if (this.typeForm == "onboarding") {
              targetsService.getAll().then(response => {
                if (response.length > 0) {
                  this.loadTarget(response[response.length - 1].id);
                  this.goToSubStep(3, 1);
                }
              });
            }
          });
        });
    },

    savenow(
      changeTargetStatusToActive,
      redirect,
      redictoToOtherTarget = false
    ) {
      this.runSavenowChecks(
        changeTargetStatusToActive,
        redirect,
        redictoToOtherTarget
      );
    },

    runSavenowChecks(
      changeTargetStatusToActive,
      redirect,
      redictoToOtherTarget = false
    ) {
      if (
        this.modelform.sales.length == 0 &&
        (this.target_status_id == 4 || this.target_status_id == 1)
      ) {
        this.$swal({
          type: "warning",
          title: this.$t("lang.label.attention"),
          text: this.$t("lang.label.order_without_sales"),
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33a2c",
          confirmButtonText: this.$t("lang.button.ok"),
        }).then((res) => {
          if (res.value) {
            this.savenowOk(
              changeTargetStatusToActive,
              redirect,
              redictoToOtherTarget
            );
          }
        });
      } else {
        this.savenowOk(
          changeTargetStatusToActive,
          redirect,
          redictoToOtherTarget
        );
      }
    },

    savenowOk(
      changeTargetStatusToActive,
      redirect,
      redictoToOtherTarget = false
    ){

      this.saving = true;
      this.setOrderData();
      let onboarding = this.onBoarding.orderdata;

      if (
        this.hasPermissions("superAdminTargets") &&
        this.simplify &&
        this.editPrice
      ) {
        onboarding.price = this.onBoarding.step3.appointmentPrice;
      }

      if (this.simplify) {
        //onboarding.updateSales = this.onBoarding.step3.updateSales;
        if (this.targetId) {
          onboarding.updateSales = this.onBoarding.step3.updateSales;
        } else {
          onboarding.salesRep = this.onBoarding.step3.updateSales;
        }
      } else {
        onboarding.salesRep = this.onBoarding.step3.teamMembers;
      }

      if (onboarding.client_id == 0) {
        onboarding.client_id = this.currentUser.client_id;
      }

      onboarding.version = this.onBoarding.version;

      if (
        this.onBoarding.modelCampaingStep.tabSelected.id == 2 &&
        this.target_status_id == 3
      ) {
        onboarding.tabSelect = this.onBoarding.modelCampaingStep.tabSelected.id;
      }
      onboarding.change_target_status_to_active = changeTargetStatusToActive;

      onboarding.bookers = this.bdrsSelected;
      onboarding.should_call_target = this.shouldCcallTarget;
      onboarding.contact_source = this.contactSource;

      if (this.onBoarding.isCopyTarget) {
        onboarding.isCopyTarget = this.onBoarding.isCopyTarget;
      }

      if (this.duplicate_reason != null) {
        onboarding.duplicate_reason = this.duplicate_reason;
      } else {
        onboarding.duplicate_reason = "New Campaign";
      }

      if(this.modelform.oldTargetId != null){
        onboarding.oldTargetId = this.modelform.oldTargetId
      }

      targetsService
        .addTarget(onboarding)
        .then(res => {
          this.modelform.oldTargetId = null
          this.saving = false;

          if (this.onBoarding.isCopyTarget) {
            const originalOrderId = this.onBoarding.isCopyTarget;
            this.setIsCopyTarget(null);

            // Abri la nueva order en una nueva pestaña
            const newOrderUrl = this.$router.resolve({ path: "/orders/" + res }).href;
            window.open(newOrderUrl, '_blank');

            // Recarga la order original en la pestaña actual
            this.setTabStep3(1);
            this.loadTarget(originalOrderId);
            this.$router.push({ path: "/orders/" + originalOrderId });
            return false
          }
          if (redictoToOtherTarget && redictoToOtherTarget.redirect) {
            this.stopTarget = false;

            this.$swal.close();
            this.$router
              .push({
                path: "/orders/" + redictoToOtherTarget.targetId,
                query: {
                  save: redictoToOtherTarget.save,
                  oldTargetId: onboarding.target_id,
                  sales: JSON.stringify(redictoToOtherTarget.sales)
                }
              })
              .then(() => {
                this.$router.go();
                return false;
              });
          } else if (redictoToOtherTarget && !redictoToOtherTarget.redirect) {
            this.$swal.close();

            this.$swal({
              type: "success",
              title: this.$t("lang.label.great"),
              text: this.$t("lang.label.datasavedsuccessfully"),
              showConfirmButton: false,
              timer: 2000
            });

            if (!redictoToOtherTarget.stayOnPage) {
              this.$router.push("/orders/");
            }
            return false;
          }

          if (redirect) {
            if (this.isIdValid(res)) {
              // if (this.oliverEmailSequence) {
              //   this.$modal.hide("start-campaings");
              //   this.loadingEmailSequence = false;
              // }
              this.setOrderId(res);
              this.targetId = res;
              this.$swal({
                type: "success",
                title: this.$t("lang.label.great"),
                text: this.$t("lang.label.datasavedsuccessfully"),
                showConfirmButton: false,
                timer: 2000
              }).then(() => {
                if (redirect) {
                  if (
                    this.onBoarding.typeForm == "onboarding" &&
                    changeTargetStatusToActive
                  ) {
                    window.location.reload();
                  } else {
                    if (this.currentUser.role_id != 1) {
                      this.$router.push("/orders/");
                    } else {
                      this.loadTarget(this.targetId);
                    }
                  }
                }
              });
            } else {
              console.log("error al guardar");
              this.$swal({
                type: "error",
                title: this.$t("lang.label.error"),
                html: this.$t("lang.general.error"),
                showConfirmButton: false,
                timer: 1500
              }).then(() => {
                if (this.typeForm == "onboarding") {
                  targetsService.getAll().then(response => {
                    if (response.length > 0) {
                      this.loadTarget(response[response.length - 1].id);
                    }
                  });
                }
              });
            }
          } else {
            if (
              this.onBoarding.targetId == 0 ||
              this.onBoarding.targetId == null
            ) {
              if (this.isIdValid(res)) {
                this.setOrderId(res);
              }
            }
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: this.$t("lang.label.error"),
            text: this.$t("lang.label.error"),
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            if (this.typeForm == "onboarding") {
              targetsService.getAll().then(response => {
                if (response.length > 0) {
                  this.loadTarget(response[response.length - 1].id);
                  this.goToSubStep(3, 1);
                }
              });
            }
          });
        });
    },

    changeStatus(status) {
      if (status == 2) {
        this.showModalStopTarget = true;
      }
      this.getTargetsByClientAndStatus(this.onBoarding.client_id, [1, 3]);

      this.$nextTick(() => {
        const swalTemplate = this.$refs.swalTemplate;

        this.$swal({
          type: "warning",
          title: "", //this.$t("lang.label.areyousure"),
          text: "",
          html: swalTemplate,
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33a2c",
          confirmButtonText: this.$t("lang.button.yes"),
          onOpen: () => {
            const confirmButton = this.$swal.getConfirmButton();
            confirmButton.setAttribute("disabled", "disabled"); // Deshabilitar el botón por defecto

            this.$watch(
              () => this.loadingTargetPreparing,
              newVal => {
                if (newVal) {
                  confirmButton.setAttribute("disabled", "disabled");
                } else {
                  confirmButton.removeAttribute("disabled");
                }
              },
              { immediate: true }
            );
          }
        }).then(result => {
          const order = {
            id: this.onBoarding.orderId,
            target_status_id: status,
            stop_reason: this.stopReason,
            mark_to_deletion:
              status == 2 && this.actionToProspectingEmails == "delete"
                ? "yes"
                : "0"
          };

          if (result.value) {
            if (
              status == 2 &&
              this.actionToProspectingEmails != "delete" &&
              this.actionToProspectingEmails != "keep"
            ) {
              this.stopTarget = true;

              this.$swal({
                icon: "warning",
                title: this.$t("lang.ondemand.processing"),
                text: this.$t("lang.search.waitplease"),
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false
              });

              const targetId = this.actionToProspectingEmails;

              targetsService.updateTarget(order).then(res => {
                if (res == order.id) {
                  if (this.typeForm == "onboarding") {
                    this.showModal("confirm");
                  }

                  const sales = this.modelform.sales;

                  this.modelform.sales = [];

                  this.updateSales(this.modelform.sales);

                  const redictoToOtherTarget = {
                    save: true,
                    sales: sales,
                    targetId: targetId,
                    redirect: true
                  };
                  this.savenow(false, false, redictoToOtherTarget);
                } else {
                  this.$swal({
                    type: "error",
                    title: this.$t("lang.label.error"),
                    text: this.$t("lang.label.error"),
                    showConfirmButton: false,
                    timer: 1500
                  });
                }
              });
            } else {
              // let order = {
              //   id: this.onBoarding.orderId,
              //   target_status_id: status,
              // };
              targetsService.updateTarget(order).then(res => {
                if (res == order.id) {
                  if (this.typeForm == "onboarding") {
                    this.showModal("confirm");
                  }
                } else {
                  this.$swal({
                    type: "error",
                    title: this.$t("lang.label.error"),
                    text: this.$t("lang.label.error"),
                    showConfirmButton: false,
                    timer: 1500
                  });
                }
              });
              if (this.simplify) {
                this.$router.push("/orders/");
              }
            }
            if (status == 2) {
              this.showModalStopTarget = false;
            }
          }
        });
      });
    },

    isIdValid(val) {
      if (val != null && val != undefined && val > 0 && val) {
        return true;
      } else {
        return false;
      }
    },

    fillSizes() {
      this.selected_sizes = [];
      this.select_list_sizes.forEach(item => {
        let label = item.label.replace("+", "").split("-");
        let less = label[0];
        let greater = label[1];
        if (
          less <= this.size.keywords.less &&
          greater >= this.size.keywords.greater
        ) {
          this.selected_sizes.push(item.id);
        }
      });
      this.updateSizes(this.selected_sizes);
    },

    fillKeywordsSizes() {
      let greater = 0;
      let less = 0;
      this.selected_sizes.sort();

      this.selected_sizes.forEach((value, index) => {
        let keywords = this.select_list_sizes[value].label
          .replace("+", "")
          .split("-");
        if (!keywords[1]) {
          keywords[1] = "10000000";
        }
        if (Number(keywords[0]) < greater || greater === 0) {
          greater = Number(keywords[0]);
        }
        if (Number(keywords[1]) > less) {
          less = Number(keywords[1]);
        }
      });

      this.size.keywords.greater = greater;
      this.size.keywords.less = less;
    },

    getSales() {
      usersService.getSales(this.targetId).then(result => {
        result.forEach(item => {
          let label =
            item.first_name + " " + item.last_name;


          let client_nylas_id =   item.client_nylas_id;

          if (!item.parent_sales_representative_id && false) {
            //(this.onBoarding == undefined || (this.onBoarding !== undefined && this.onBoarding.client_id > 5031))
            //esto aplica solo a clientes nuevos porque los viejos ya tienen comerciales ligados a targets y no podemos quitarlos porque ya tineen usuario role 2 osea prospectores enviando emails con esos sales. Si los quitamos estariamos dejanod de usar muchos mails y dominios
            //si no es un team y ademas no esta ligado a un target
            this.salesRep.push({
              id: item.id,
                  client_nylas_id: client_nylas_id,
              label: label + " (" + this.$t("lang.targets.teamassigned") + ")",
              isDisabled: true
            });
          } else {
            if (this.addOrder) {
              if (item.target_id == null) {
                if (item.warm_days != null) {
                  this.salesRep.push({
                    id: item.id,
                    client_nylas_id: client_nylas_id,
                    label:
                      label +
                      " (warmup: " +
                      item.warm_days +
                      this.$t("lang.label.days") +
                      ")",
                    total_active: item.total_active,
                    total_warming_up: item.total_warming_up,
                    total_stopped: item.total_stopped,
                    total_not_first_sync: item.total_not_first_sync
                  });
                } else {
                  this.salesRep.push({
                    id: item.id,
                  client_nylas_id: client_nylas_id,
                    label: item.email,
                    total_active: item.total_active,
                    total_warming_up: item.total_warming_up,
                    total_stopped: item.total_stopped,
                    total_not_first_sync: item.total_not_first_sync
                  });
                }
              } else {
                this.salesRep.push({
                  id: item.id,
                  client_nylas_id: client_nylas_id,
                  label:
                    label +
                    " (" +
                    this.$t("lang.targets.salesunavailable") +
                    ")",
                  isDisabled: true,
                  total_active: item.total_active,
                  total_warming_up: item.total_warming_up,
                  total_stopped: item.total_stopped,
                  total_not_first_sync: item.total_not_first_sync
                });
              }
            } else {
              if (
                item.target_id == null ||
                item.target_id == this.onBoarding.orderId
              ) {
                this.salesRep.push({
                  id: item.id,
                  label: label,
                  client_nylas_id: client_nylas_id,
                  total_active: item.total_active,
                  total_warming_up: item.total_warming_up,
                  total_stopped: item.total_stopped,
                  total_not_first_sync: item.total_not_first_sync
                });
              } else {

              }
              if (item.target_id == this.onBoarding.orderId) {
                this.modelform.sales.push(item.id);
              }
            }
          }

          this.updateSales(this.modelform.sales);
        });

        this.loadingSales = false;
      });
    },
    changeLanguage(save) {
      let language_id;
      language_id = 1;
      if (this.onBoarding.lang == "fr") {
        language_id = 1;
      }
      if (this.onBoarding.lang == "en") {
        language_id = 2;
      }
      if (this.onBoarding.lang == "es") {
        language_id = 3;
      }

      if (this.onBoarding.lang == "it") {
        language_id = 4;
      }

      if (this.onBoarding.lang == "pt") {
        language_id = 5;
      }

      this.setLanguageId(language_id);
      if (save) {
        this.closeEdit("language");
      }
    },
    changeOrderName(e) {
      this.updateOrderName(e.target.value);
    },

    changeOfferBenefits(e) {
      this.updateBenefitsOffer(e.target.value);
    },
    changeDescriptionSell(e) {
      if (this.onBoarding.descriptionSell.length > 800) {
        this.onBoarding.descriptionSell = this.onBoarding.descriptionSell.slice(
          0,
          800
        );
      } else {
        this.updateDescriptionSell(e.target.value);
      }
    },
    changeDescriptionOrder(e) {
      this.updateDescriptionOrder(e.target.value);
    },
    changeColdCallScriptSpecifications(e){
      this.updateColdCallspec(e.target.value);
    },
    generateColdCallSpecifications() {
      if (this.generatingColdCallSpec) {
        return;
      }
      this.generatingColdCallSpec = true;
      targetsService
        .getDataColdCallSpecifications(this.targetId)
        .then(text => {
          this.updateColdCallspec(text);
        })
        .catch(() => {
          this.$swal({
            type: "error",
            title: this.$t("lang.label.error"),
            text: this.$t("lang.onBoarding.generateColdCallSpecificationsError"),
            showConfirmButton: true,
          });
        })
        .finally(() => {
          this.generatingColdCallSpec = false;
        });
    },
    changeOfferAttractive(e) {
      this.updateOfferAttractive(e.target.value);
    },
    changeBenefitsOffer(e) {
      this.updateBenefitsOffer(e.target.value);
    },
    changeProductName(e) {
      this.updateProductName(e.target.value);
    },

    changeWebsite(e) {
      if (this.$refs.websiteForm.errors.length > 0) {
        return;
      }
      this.updateWebsite(this.modelform.website);
      this.closeEdit("website");
    },
    changeAppointmentVolume(e) {
      if (e.target.value < 3) {
        this.formValidation.appointment = true;
      } else {
        this.formValidation.appointment = false;
      }
      this.updateAppointmentVolume(this.onBoarding.step3.appointmentVolume);
    },
    changeAppointmentPrice(e) {
      if (e.target.value != this.onBoarding.step3.appointmentPrice) {
        if (e.target.value < 0) {
          e.target.value = 149;
        }
        this.editPrice = true;
        this.updatePrice(e.target.value);
      }
    },
    changeNewEmailsPerDay(e) {
      if (e.target.value != this.onBoarding.step3.newEmailsPerDay) {
        if (e.target.value < 0) {
          e.target.value = 100;
        }
        // this.closeEdit("editingNewEmailsPerDay");
        this.updateNewEmailsPerDay(e.target.value);
      }
    },
    changeTotalEmailsPerDay(e) {
      if (e.target.value != this.onBoarding.step3.totalEmailsPerDay) {
        if (e.target.value < 0) {
          e.target.value = 200;
        }
        // this.closeEdit("editingTotalEmailsPerDay");
        this.updateTotalEmailsPerDay(e.target.value);
      }
    },
    changeLaunchDate() {
      this.$refs.launchDateForm.validate();
      if (this.$refs.launchDateForm.errors.length > 0) {
        return;
      }
      this.updateLaunchDate(this.modelform.launchDate);
      this.closeEdit("launchDate");
    },
    padTo2Digits(num) {
      return num.toString().padStart(2, "0");
    },

    verificateOrder() {
      targetsService.verificateTarget(this.verificationOrder).then(res => {
        this.$swal({
          type: "success",
          title: this.$t("lang.label.great"),
          text: this.$t("lang.label.datasavedsuccessfully"),
          showConfirmButton: false,
          timer: 2000
        });
      });
      this.editing["verified"] = false;
      this.$forceUpdate();
    },

    changeVerificateOrder(verificate) {
      verificate.target_id = this.targetId;
      this.verificationOrder = verificate;
    },
    trainingPass() {
      if (this.training_check && this.trainingCheck_2 && this.trainingCheck_3) {
        this.$modal.hide("videotraining");
        let target_id = 0;
        if (this.currentUser.created_from_admin != "1") {
          this.savenow(true, true);
          target_id = !this.targetId ? this.onBoarding.orderId : this.targetId;
        }
        targetsService.addOnboardingFinish(target_id).then(res => {
          window.location.reload();
        });
      }
    },

    changeTab(tab) {
      this.setTab(tab);
    },

    changeTabStep3(tab) {
      this.setTabStep3(tab);
      if (tab == 3) {
        //this.getApollo("saved");
      }
    },

    stopSendingForThisMonth(hours) {
      // restriction only for the entire month
      if (!this.availableStopSendingForThisMonth && hours === undefined) {
        return false;
      }

      this.$swal({
        type: "warning",
        title: this.$t("lang.label.areyousure"),
        text: "",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t("lang.button.yes")
      }).then(result => {
        if (result.value) {
          targetsService.stopThisMonth(this.onBoarding.orderId, hours).then(
            res => {
              if (hours != undefined && hours > 0) {
                this.setHoursPaused(hours);
              } else {
                this.setHoursPaused(0);
                this.setIsMonthlyPaused(true);
              }
            },
            error => {
              this.$swal({
                type: "warning",
                title: this.$t("lang.label.error"),
                text: this.$t("lang.general." + error),
                showCancelButton: true
              });
            }
          );
        }
      });
    },

    duplicate() {
      const comOption =
        this.currentUser.role_id == 1
          ? '<option value="COM">COM</option>'
          : "";
      this.$swal({
        type: "warning",
        title: this.$t("lang.label.areyousure"),
        text: "",
        html: `
        <div>
          <small for="duplicateReason">${this.$t(
            "lang.onBoarding.duplicate_reason"
          )}</small>
          <select id="duplicateReason" class="form-control" v-model='duplicate_reason'>
            <option value="A/B testing">A/B testing</option>
            <option value="New order">New order</option>
            <option value="Prospectors spin">Prospectors spin</option>
            ${comOption}
          </select>
        </div>
      `,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t("lang.button.yes"),
        preConfirm: () => {
          const duplicateReason = this.$swal
            .getPopup()
            .querySelector("#duplicateReason").value;
          if (!duplicateReason) {
            this.$swal.showValidationMessage(
              this.$t("lang.error.selectReason")
            );
          }
          return { duplicateReason: duplicateReason };
        }
      }).then(result => {
        if (result.value) {
          this.loadingSales = true;
          this.duplicate_reason = result.value.duplicateReason;
          this.copy(this.onBoarding.step3.appointmentPrice);
          this.modelform.sales = [];
          this.salesRep = [];
          this.addOrder = true;
          this.getSales();
        }
      });
    },

    formatDate() {
      return moment()
        .startOf("day")
        .format("YYYY-MM-DD");
    },

    textQtyCharactersGlobal(field) {
      const qty = field ? field.length : 0;
      return `( ${qty} / 2000 )`;
    },
    correctNumberCharactersGlobal(field) {
      const qty = field ? field.length : 0;
      return qty > 2000 ? false : true;
    },

    //cargamos de nuevo el componente para que obtenga un nuevo email.
    generateNew() {
      this.regenerateEmail = true;
      setTimeout(() => {
        this.regenerateEmail = false;
      }, 300);
    },

    contractConfirmation() {
      this.$swal({
        type: "warning",
        title: this.$t("lang.onBoarding.start_preparing_my_campaigns_month"),
        //html: this.$t("lang.onBoarding.confirm_preparing_campaign"),
        html: "hola",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t("lang.button.yes")
      }).then(result => {
        if (result.value) {
          // if (this.previewTemplate()) {
          //   this.savenow(true, true);
          // } else {

          this.$modal.show("videotraining");
          //this.savenow(false, true);
          // }
          return false;
        }
      });
    },

    refreshPaymentMethods() {
      this.$modal.hide("confirm");
      setTimeout(() => {
        //this.contractConfirmation();
        this.$modal.show("videotraining");
        //this.modalContractConfirmation('open')
      }, 1500);
    },

    closeCreditCardModal() {
      this.$modal.hide("confirm");
    },

    checkSequence() {
      this.emptySequence = true;
    },
    checkValidation() {
      let validation = this.validateForm();
      return validation;
    },

    generateSequences() {
      this.sequences_IA_loading = true;

      let sendData = {
        targetId: this.onBoarding.orderId
      };
      //onsole.log(this.modelCampaingStep);
      targetSequencesService.generateSequences(sendData).then(res => {
        this.sequences_IA = res;

        this.sequences_IA_loading = false;
      });
    },
    //Guardamos los mensajes personalizados de la campagña
    saveTargetCampaignStep(data) {
      this.$modal.hide("mails");
      this.modelCampaingStep = data;
      if (
        this.currentUser.role_id == 1 &&
        this.onBoarding.modelCampaingStep.campaign_steps[0].id == undefined
      ) {
        this.$swal({
          type: "warning",
          title: this.$t("lang.label.acceptChangeCustomTemplate"),
          text: "",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33a2c",
          confirmButtonText: this.$t("lang.button.yes")
        }).then(result => {
          if (result.value) {
            this.modelCampaingStep = data;
            targetsService.addCampaignStep(this.modelCampaingStep).then(res => {
              if (res) {
                if (res.length > 0) {
                  this.modelCampaingStep.campaign_steps = res;
                  this.setCampaingSteps(res);
                  this.setDisabledTab(2);
                  this.$swal({
                    type: "success",
                    title: this.$t("lang.label.great"),
                    text: this.$t("lang.label.datasavedsuccessfully"),
                    showConfirmButton: false,
                    timer: 2000
                  }).then(() => {
                    this.$modal.show("mails");
                  });
                }
              }
            });
          }
        });
      } else {
        targetsService.addCampaignStep(this.modelCampaingStep).then(res => {
          if (res) {
            if (res.length > 0) {
              this.$swal({
                type: "success",
                title: this.$t("lang.label.great"),
                text: this.$t("lang.label.datasavedsuccessfully"),
                showConfirmButton: false,
                timer: 2000
              }).then(() => {
                this.$modal.show("mails");
              });
              this.modelCampaingStep.campaign_steps = res;
              this.setCampaingSteps(res);
            }
          }
        });
      }
    },

    updateActiveWarmup(e) {
      const newValue = e.target.checked ? 1 : 0;
      this.setWarmupActive(newValue);
    },

    updateCreateMailboxes(e) {
      const newValue = e.target.checked ? 1 : 0;
      this.setCreateMailboxes(newValue);
    },

    changeDescriptionSellMinCharacter(e) {
      if (this.onBoarding.descriptionSell.length < 150) {
        this.$swal({
          type: "error",
          title: this.$t("lang.validation.min_characters"),
          showConfirmButton: false,
          timer: 1500
        });
      }
    },
    setDuplicateReason() {
      this.duplicate_reason = this.onBoarding.step3.duplicate_reason;
      this.updateDuplicateReason(this.duplicate_reason);
    },
    getPlaceholder() {
      const lang = this.$store.state.onboarding.lang;
      const placeholderBase = this.$t(
        "lang.onBoarding.step1_4_1_example",
        lang
      );
      const minLength = 150;
      return (
        placeholderBase +
        (this.onBoarding.descriptionSell.length < minLength
          ? ` (Minimum ${minLength} characters)`
          : "")
      );
    },

    goToClient(client_id, client_name) {
      //(client_id, this.hasPermissions('isAgencyManager'), this.$store.state.authentication.user.role_id);
      let url = "/clients/" + client_id;
      window.open(url, "_blank");
    },
    exportOrderData() {
      const targetId = this.targetId || this.onBoarding.orderId;
      if (!targetId) return;
      this.loadingOrderDataExport = true;
      clientsService
        .getAIContextByTarget(targetId)
        .then((res) => {
          this.downloadOrderDataJson(res);
        })
        .catch(() => {})
        .finally(() => {
          this.loadingOrderDataExport = false;
        });
    },
    downloadOrderDataJson(data) {
      const jsonString = JSON.stringify(data, null, 2);
      const targetId = this.targetId || this.onBoarding.orderId;
      const filename = `order-data-export-${targetId}-${new Date().toISOString().slice(0, 10)}.txt`;
      const blob = new Blob([jsonString], { type: "text/plain;charset=utf-8" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }
  }
};
</script>
<style scoped>

.selectCustom {
  max-height: 200px;
  overflow-y: scroll;
}

.btn_pause {
  background-color: #ffc107;
}
.bg-paused {
  background-color: #fefcdd;
  border: 3px solid #faf879;
  color: #abaaa3;
  font-weight: 700;
}

.text-size-14 {
  font-size: 14px;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.border-style-dashed {
  border-style: dashed;
  border-bottom: 1px dashed;
  border-top: 0px;
  border-left: 0px;
  border-right: 0px;
}
.circle {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  font-size: 11px;
}

.bg-custon-gray {
  background-color: #f1f1fd;
}

.circle-custom {
  border-radius: 100%;
  width: 70px;
  height: 70px;
  border: 6px;
}

.border-custom-right {
  border-right: 7px solid blue;
  height: 36px;
}

.border-custom-right-hide {
  height: 36px;
}

.content-center {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
